<template>
  <div class="index">
    <div class="index-pc-live" v-if="radioListItems">
      <div class="index-live-bg" v-if="isIeState">
        <img src="../../static/img/ie/live-1536.png" alt="">
      </div>
      <div class="index-live-bg" v-else>
        <img v-lazy="{src:curRadioListItems.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
      </div>
      <div class="index-live-bgCurrent"></div>
      <div class="index-live-con">
        <div class="index-live-control cg-mainWrapper">
          <div class="toLive">
            <a href="/CGTNRadioLive" target="_blank"></a>
          </div>
          <div class="index-live-pic fl">
            <img v-lazy="{src:curRadioListItems.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
          </div>
          <div class="index-live-current-info fl">
            <div class="top">
              <div class="js-live-play js-play play" :data-pic="curRadioListItems.programUrlTwo" :data-showName="curRadioListItems.columnTitle" :data-url="curRadioListItems.mediaUrl" data-type="live" data-linkUrl="https://radio.cgtn.com/" data-groupName="" @click="play($event)"></div>
              <div class="onAir">
                <h3 class="onAir-time">On Air : <span>{{curRadioListItems.startTime}}-{{curRadioListItems.stopTime}}</span></h3>
                <!-- <h1 class="onAir-name" v-if="'programLinkUrl' in curRadioListItems && curRadioListItems.programLinkUrl">
                  <aLink :toPath="curRadioListItems.programLinkUrl">{{curRadioListItems.columnTitle}}</aLink>
                </h1>
                <h1 class="onAir-name" v-else>
                  {{curRadioListItems.columnTitle}}
                </h1> -->
                <section v-if="curRadioListItems.columnTitle">
                  <h1 class="onAir-name" :class="{'loneTitle':isLoneTitleStyle}">
                    <section v-if="'programLinkUrl' in curRadioListItems && curRadioListItems.programLinkUrl">
                      <aLink :toPath="curRadioListItems.programLinkUrl">
                        <span>{{curRadioListItems.columnTitle}}</span>
                      </aLink>
                    </section>
                    <section v-else>
                      <span>{{curRadioListItems.columnTitle}}</span>
                    </section>
                  </h1>
                </section>
              </div>
            </div>
            <div class="bottom">
              <p class="onAir-summary">
                {{curRadioListItems.info}}
              </p>
            </div>
          </div>
          <div class="index-live-next-info fl">
            <div class="next" v-if="'nextProgramLinkUrl' in curRadioListItems && curRadioListItems.nextProgramLinkUrl">
              <h3 class="next-time">Next: <span v-show="'nextStartTime' in curRadioListItems">{{curRadioListItems.nextStartTime}}-{{curRadioListItems.nextStopTime}}</span></h3>
              <div class="next-name" v-show="'nextColumnTitle' in curRadioListItems">
                <aLink :toPath="curRadioListItems.nextProgramLinkUrl">{{curRadioListItems.nextColumnTitle}}</aLink>
              </div>
            </div>
            <div class="next" v-else>
              <h3 class="next-time">Next: <span v-show="'nextStartTime' in curRadioListItems">{{curRadioListItems.nextStartTime}}-{{curRadioListItems.nextStopTime}}</span></h3>
              <div class="next-name" v-show="'nextColumnTitle' in curRadioListItems">
                {{curRadioListItems.nextColumnTitle}}
              </div>
            </div>
          </div>
          <div class="index-live-schedule fl">
            <div class="clock">
              <aLink :toPath="showsUrl" class="clock-icon"></aLink>
            </div>
            <aLink :toPath="showsUrl" class="schedule-to">Schedule</aLink>
          </div>
        </div>
        <div class="index-live-nav">
          <div class="cg-mainWrapper">
            <div class="swiper-container channel-slide-pc">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,key) in radioListItems" :key="key">
                  <dl>
                    <dt :class="{'current':radioListPlayState == key}" :data-pic="item.programUrlTwo" :data-showName="item.columnTitle" :data-url="item.mediaUrl" data-type="live" data-linkUrl="https://radio.cgtn.com/"  data-groupName="" @click="radioListPlay($event,key)">
                      <img v-lazy="{src:item.programUrl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                      <div class="pic-mask"></div>
                      <div class="playingGif"><img src="../../static/img/playing.gif" alt=""></div>
                    </dt>
                    <dd>
                      <h3 v-if="'liveLinkUrl' in item && item.liveLinkUrl"><aLink :toPath="item.liveLinkUrl">{{item.title}}</aLink></h3>
                      <h3 v-else>{{item.title}}</h3>
                      <p v-if="'programLinkUrl' in item && item.programLinkUrl">
                        <aLink :toPath="item.programLinkUrl">{{item.columnTitle}}</aLink>
                      </p>
                      <p v-else>{{item.columnTitle}}</p>
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="channel-slide-pc-arrows-current"></div>
              <div class="channel-slide-pc-arrows">
                <div class="channel-slide-pc-arrow channel-slide-pc-arrow-left"></div>
                <div class="channel-slide-pc-arrow channel-slide-pc-arrow-right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-pad-live" ref="js_index_pad_live" v-if="radioListItems">
      <div class="index-live-bg">
        <img v-lazy="{src:curRadioListItems.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
      </div>
      <div class="index-live-bgCurrent"></div>
      <div class="index-live-con">
        <div class="index-live-control cg-mainWrapper" ref="index_live_control_pad">
          <div class="toLive">
            <a href="/CGTNRadioLive" target="_blank"></a>
          </div>
          <div class="index-live-pic">
            <img v-lazy="{src:curRadioListItems.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
          </div>
          <div class="index-live-info">
            <div class="top">
              <div class="js-live-play js-play play" :data-pic="curRadioListItems.programUrlTwo" :data-showName="curRadioListItems.columnTitle" :data-url="curRadioListItems.mediaUrl" data-type="live" data-linkUrl="https://radio.cgtn.com/" data-groupName="" @click="play($event)"></div>
              <div class="onAir">
                <h3 class="onAir-time">On Air : <span>{{curRadioListItems.startTime}}-{{curRadioListItems.stopTime}}</span></h3>
                <section v-if="curRadioListItems.columnTitle">
                  <h1 class="onAir-name">
                    <section v-if="'programLinkUrl' in curRadioListItems && curRadioListItems.programLinkUrl">
                      <aLink :toPath="curRadioListItems.programLinkUrl">
                        <span>{{curRadioListItems.columnTitle}}</span>
                      </aLink>
                    </section>
                    <section v-else>
                      <span>{{curRadioListItems.columnTitle}}</span>
                    </section>
                  </h1>
                </section>
              </div>
            </div>
            <div class="bottom">
              <p class="onAir-summary">
                {{curRadioListItems.info}}
              </p>
            </div>
          </div>
        </div>
        <div class="index-live-schedule cg-mainWrapper" ref="index_live_schedule_pad">
          <div class="wrapper">
            <div class="clock">
              <aLink :toPath="showsUrl" class="schedule-to">Schedule</aLink>
            </div>
            <div class="index-live-next-info" v-if="'nextProgramLinkUrl' in curRadioListItems && curRadioListItems.nextProgramLinkUrl">
              <h3 class="time">Next: <span v-show="'nextStartTime' in curRadioListItems">{{curRadioListItems.nextStartTime}}-{{curRadioListItems.nextStopTime}}</span></h3>
              <h3 class="name" v-show="'nextColumnTitle' in curRadioListItems" ref="columnTitleParentPad">
                <!-- <aLink :toPath="curRadioListItems.nextProgramLinkUrl">{{curRadioListItems.nextColumnTitle}}</aLink> -->
                <span :style="textStylePad" class="hoverStyle" ref="columnTitleChildPad" @click="columnTitleToLink(curRadioListItems.nextProgramLinkUrl)">{{curRadioListItems.nextColumnTitle}}</span>
              </h3>
            </div>
            <div class="index-live-next-info" v-else>
              <h3 class="time">Next: <span v-show="'nextStartTime' in curRadioListItems">{{curRadioListItems.nextStartTime}}-{{curRadioListItems.nextStopTime}}</span></h3>
              <h3 class="name" v-show="'nextColumnTitle' in curRadioListItems" ref="columnTitleParentPad">
                <span :style="textStylePad" ref="columnTitleChildPad">{{curRadioListItems.nextColumnTitle}}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="index-live-nav" ref="index_live_nav_pad">
          <div class="cg-mainWrapper">
            <div class="swiper-container channel-slide-pad">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,key) in radioListItems" :key="key">
                  <dl>
                    <dt :class="{'current':radioListPlayState == key}" :data-pic="item.programUrlTwo" :data-showName="item.columnTitle" :data-url="item.mediaUrl" data-type="live" data-linkUrl="https://radio.cgtn.com/"  data-groupName="" @click="radioListPlay($event,key)">
                      <img v-lazy="{src:item.programUrl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                      <div class="pic-mask"></div>
                      <div class="playingGif"><img src="../../static/img/playing.gif" alt=""></div>
                    </dt>
                    <dd>
                      <h3 v-if="'liveLinkUrl' in item && item.liveLinkUrl"><aLink :toPath="item.liveLinkUrl">{{item.title}}</aLink></h3>
                      <h3 v-else>{{item.title}}</h3>
                      <p v-if="'programLinkUrl' in item && item.programLinkUrl">
                        <aLink :toPath="item.programLinkUrl">{{item.columnTitle}}</aLink>
                      </p>
                      <p v-else>{{item.columnTitle}}</p>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="channel-slide-pad-arrow channel-slide-pad-arrow-left"></div>
            <div class="channel-slide-pad-arrow channel-slide-pad-arrow-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-m-live" ref="js_index_m_live" v-if="radioListItems">
      <div class="index-live-bg">
        <img v-lazy="{src:curRadioListItems.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
      </div>
      <div class="index-live-bgCurrent"></div>
      <div class="index-live-con">
        <div class="toLive">
          <a href="/CGTNRadioLive" target="_blank"></a>
        </div>
        <div class="index-live-control cg-mainWrapper" ref="index_live_control_m">
          <div class="top">
            <div class="index-live-pic">
              <img v-lazy="{src:curRadioListItems.programUrlTwo,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
            </div>
            <div class="index-live-info">
              <div class="js-live-play js-play play" :data-pic="curRadioListItems.programUrlTwo" :data-showName="curRadioListItems.columnTitle" :data-url="curRadioListItems.mediaUrl" data-type="live" data-linkUrl="https://radio.cgtn.com/" data-groupName="" @click="play($event)"></div>
              <div class="onAir">
                <h3 class="onAir-time">On Air : <span>{{curRadioListItems.startTime}}-{{curRadioListItems.stopTime}}</span></h3>
                <section v-if="curRadioListItems.columnTitle">
                  <h1 class="onAir-name">
                    <section v-if="'programLinkUrl' in curRadioListItems && curRadioListItems.programLinkUrl">
                      <aLink :toPath="curRadioListItems.programLinkUrl">
                        <span>{{curRadioListItems.columnTitle}}</span>
                      </aLink>
                    </section>
                    <section v-else>
                      <span>{{curRadioListItems.columnTitle}}</span>
                    </section>
                  </h1>
                </section>
              </div>
            </div>
          </div>
          <div class="bottom">
            <p class="onAir-summary">
              {{curRadioListItems.info}}
            </p>
          </div>
        </div>
        <div class="index-live-schedule cg-mainWrapper" ref="index_live_schedule_m">
          <div class="wrapper">
            <div class="index-live-next-info">
              <div class="con" v-if="'nextProgramLinkUrl' in curRadioListItems && curRadioListItems.nextProgramLinkUrl">
                <div class="time">
                  Next: <span v-show="'nextStartTime' in curRadioListItems">{{curRadioListItems.nextStartTime}}-{{curRadioListItems.nextStopTime}}</span>
                </div>
                <div class="title" ref="columnTitleParentWap">
                  <span :style="textStyleWap" class="hoverStyle" ref="columnTitleChildWap" @click="columnTitleToLink(curRadioListItems.nextProgramLinkUrl)">{{curRadioListItems.nextColumnTitle}}</span>
                </div>
              </div>
              <div class="con" v-else>
                <div class="time">
                  Next: <span v-show="'nextStartTime' in curRadioListItems">{{curRadioListItems.nextStartTime}}-{{curRadioListItems.nextStopTime}}</span>
                </div>
                <div class="title" ref="columnTitleParentWap">
                  <span :style="textStyleWap" ref="columnTitleChildWap">{{curRadioListItems.nextColumnTitle}}</span>
                </div>
              </div>
            </div>
            <div class="clock">
              <i></i>
              <aLink :toPath="showsUrl" class="schedule-to">Schedule</aLink>
            </div>
          </div>
        </div>
        <div class="index-live-nav" ref="index_live_nav_m">
          <div class="cg-mainWrapper">
            <div class="swiper-container channel-slide-m">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,key) in radioListItems" :key="key">
                  <dl>
                    <dt :class="{'current':radioListPlayState == key}" :data-pic="item.programUrlTwo" :data-showName="item.columnTitle" :data-url="item.mediaUrl" data-type="live" data-linkUrl="https://radio.cgtn.com/"  data-groupName="" @click="radioListPlay($event,key)">
                      <img v-lazy="{src:item.programUrl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                      <div class="pic-mask"></div>
                      <div class="playingGif"><img src="../../static/img/playing.gif" alt=""></div>
                    </dt>
                    <dd>
                      <h3 v-if="'liveLinkUrl' in item && item.liveLinkUrl"><aLink :toPath="item.liveLinkUrl">{{item.title}}</aLink></h3>
                      <h3 v-else>{{item.title}}</h3>
                      <p v-if="'programLinkUrl' in item && item.programLinkUrl">
                        <aLink :toPath="item.programLinkUrl">{{item.columnTitle}}</aLink>
                      </p>
                      <p v-else>{{item.columnTitle}}</p>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section v-for="(item,key) in lanes" :key="key">
      <div class="index-fourPic mod" v-if="item.styleType == 0">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
          <div class="index-fourPic-con clearfloat js-lane-height" v-if="item.data && item.data.length > 0">
            <dl v-for="(newsItem,key) in item.data.slice(0,4*item.rows)" :key="key">
              <dt>
                <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
              </dt>
              <dd>
                <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                <p>{{newsItem.info}}</p>
                <div class="js-play play" v-if="newsItem.isCanPlay" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)">
                  <div class="icon">LISTEN</div>
                  <div class="time">{{newsItem.duration}}</div>
                </div>
                <div class="js-play play forbidden" v-else></div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="index-radio-pc mod" v-if="item.styleType == 1">
        <div class="index-radio-con" v-if="item.data && item.data.length > 0">
          <div class="index-radio-bg" v-if="isIeState">
            <img src="/static/img/ie/recomend-banner-1536.png" alt="">
          </div>
          <div class="index-radio-bg" v-else>
            <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
          </div>
          <div class="index-radio-info" v-if="item.data[0].type != 'linkUrl'">
            <div class="cg-mainWrapper">
              <div class="pic">
                <aLink :toPath="item.data[0].fromUrl">
                  <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </aLink>
              </div>
              <div class="info">
                <h3><aLink :toPath="item.data[0].fromUrl">{{item.data[0].columnName}}</aLink></h3>
                <div class="js-play play" :data-pic="item.data[0].sharePicurl" :data-showName="item.data[0].shareTitle" :data-url="item.data[0].mediaUrl" data-type="mp3" :data-linkUrl="item.data[0].shareFromUrl" :data-countryCode="item.data[0].countryRegionLimit" :data-groupName="item.data[0].groupName" @click="play($event)"><div class="icon">LISTEN</div> <div class="time">{{item.data[0].duration}}</div></div>
                <p>{{item.data[0].columnDetail}}</p>
              </div>
            </div>
          </div>
          <div class="index-radio-info" v-else>
            <div class="cg-mainWrapper">
              <div class="pic">
                <aLink :toPath="item.data[0].url">
                  <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </aLink>
              </div>
              <div class="info">
                <h3><aLink :toPath="item.data[0].url">{{item.data[0].title}}</aLink></h3>
                <p>{{item.data[0].detail}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="index-radio-con tl-banner" v-else>
          <div class="cg-mainWrapper">
            <div class="tl-banner-con">
              <a :href="item.linkUrl">
                <img v-lazy="{src:item.bannerPicurl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="index-radio-pad mod" v-if="item.styleType == 1">
        <div class="cg-mainWrapper">
          <div class="index-radio-con" v-if="item.data && item.data.length > 0">
            <div class="index-radio-bg" v-if="isIeState">
              <img src="/static/img/ie/recomend-banner-1536.png" alt="">
            </div>
            <div class="index-radio-bg" v-else>
              <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
            </div>
            <div class="index-radio-info" v-if="item.data[0].type != 'linkUrl'">
              <div class="pic">
                <aLink :toPath="item.data[0].fromUrl">
                  <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </aLink>
                <div class="js-play play" :data-pic="item.data[0].sharePicurl" :data-showName="item.data[0].shareTitle" :data-url="item.data[0].mediaUrl" data-type="mp3" :data-linkUrl="item.data[0].shareFromUrl" :data-countryCode="item.data[0].countryRegionLimit" :data-groupName="item.data[0].groupName" @click="play($event)"><div class="icon">LISTEN</div> <div class="time">{{item.data[0].duration}}</div></div>
              </div>
              <h3><aLink :toPath="item.data[0].fromUrl">{{item.data[0].columnName}}</aLink></h3>
              <p>{{item.data[0].columnDetail}}</p>
            </div>
            <div class="index-radio-info" v-else>
              <div class="pic">
                <aLink :toPath="item.data[0].url">
                  <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </aLink>
              </div>
              <h3><aLink :toPath="item.data[0].url">{{item.data[0].title}}</aLink></h3>
              <p>{{item.data[0].detail}}</p>
            </div>
          </div>
          <div class="index-radio-con tl-banner" v-else>
            <div class="cg-mainWrapper">
              <div class="tl-banner-con">
                <a :href="item.linkUrl">
                  <img v-lazy="{src:item.bannerPicurl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-radio-m mod" v-if="item.styleType == 1">
        <div class="cg-mainWrapper">
          <div class="index-radio-con" v-if="item.data && item.data.length > 0">
            <div class="index-radio-bg" v-if="isIeState">
              <img src="/static/img/ie/recomend-banner-1536.png" alt="">
            </div>
            <div class="index-radio-bg" v-else>
              <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
            </div>
            <div class="index-radio-info" v-if="item.data[0].type != 'linkUrl'">
              <div class="pic">
                <aLink :toPath="item.data[0].fromUrl">
                  <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </aLink>
                <div class="js-play play" :data-pic="item.data[0].sharePicurl" :data-columnName="item.data[0].shareTitle" :data-showName="item.data[0].shareTitle" :data-url="item.data[0].mediaUrl" data-type="mp3" :data-linkUrl="item.data[0].shareFromUrl" :data-countryCode="item.data[0].countryRegionLimit" :data-groupName="item.data[0].groupName" @click="play($event)"><div class="icon">LISTEN</div> <div class="time">{{item.data[0].duration}}</div></div>
              </div>
              <h3><aLink :toPath="item.data[0].fromUrl">{{item.data[0].columnName}}</aLink></h3>
              <p>{{item.data[0].columnDetail}}</p>
            </div>
            <div class="index-radio-info" v-else>
              <div class="pic">
                <aLink :toPath="item.data[0].url">
                  <img v-lazy="{src:item.backgroundPicUrl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </aLink>
              </div>
              <h3><aLink :toPath="item.data[0].url">{{item.data[0].title}}</aLink></h3>
              <p>{{item.data[0].detail}}</p>
            </div>
          </div>
          <div class="index-radio-con tl-banner" v-else>
            <div class="cg-mainWrapper">
              <div class="tl-banner-con">
                <a :href="item.linkUrl">
                  <img v-lazy="{src:item.bannerPicurl,loading:require('../../static/img/loading/loading-banner.jpg'),error:require('../../static/img/loading/loading-banner.jpg')}" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-fivePic-pc mod" v-if="item.styleType == 2">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
          <div class="index-fivePic-con clearfloat js-lane-height" v-if="item.data && item.data.length > 0">
            <dl v-for="(newsItem,key) in item.data.slice(0,5*item.rows)" :class="{'rtl':newsItem.groupName === 'ar'}" :key="key">
              <dt>
                <aLink :toPath="newsItem.url"><img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt=""></aLink>
              </dt>
              <dd>
                <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                <p>{{newsItem.info}}</p>
                <div class="js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3"  :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)">
                  <div class="time">{{newsItem.duration}}</div>
                </div>
                <aLink :toPath="newsItem.url" class="more">
                  <i></i><span>MORE EPISODES</span>
                </aLink>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="index-fivePic-m mod" v-if="item.styleType == 2">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
          <div class="index-fivePic-con clearfloat" v-if="item.data && item.data.length > 0">
            <div class="news-item" v-for="(newsItem,key) in item.data.slice(0,5*item.rows)" :class="{'rtl':newsItem.groupName === 'ar'}" :key="key">
              <div class="info">
                <div class="pic">
                  <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                  <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                </div>
                <div class="txt">
                  <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                  <p>{{newsItem.info}}</p>
                  <div class="js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)">
                    <div class="icon">LISTEN</div>
                    <div class="time">{{newsItem.duration}}</div>
                  </div>
                </div>
              </div>
              <div class="more">
                <aLink :toPath="newsItem.url" class="more">
                  <i></i><span>MORE EPISODES</span>
                </aLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-popular mod" v-if="item.styleType == 3">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
        </div>
        <div class="index-popular-con" v-if="item.data && item.data.length > 0">
          <div class="cg-mainWrapper">
            <div class="left">
              <dl v-for="(newsItem,key) in item.data.slice(0,1)" :key="key">
                <dt>
                  <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                  <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                </dt>
                <dd>
                  <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                  <div class="js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)">
                    <div class="time">{{newsItem.duration}}</div>
                  </div>
                </dd>
              </dl>
            </div>
            <div class="right">
              <dl v-for="(newsItem,key) in item.data.slice(1,7)" :key="key">
                <dt>
                  <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                  <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                </dt>
                <dd>
                  <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                  <div class="js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)">
                    <div class="time">{{newsItem.duration}}</div>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="shows-recomended mod" v-if="item.styleType == 4">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
          <div class="picLeftW500H281-pc con" v-if="item.data && item.data.length > 0">
            <dl v-for="(newsItem,key) in item.data.slice(0,4)" :class="{'rtl':newsItem.groupName === 'ar' || newsItem.typeGroup === 'ar'}" :key="key">
              <dt>
                <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
              </dt>
              <dd>
                <div class="source" v-if="newsItem.fromUrl">
                  From : <aLink :toPath="newsItem.fromUrl">{{newsItem.columnName}}</aLink>
                </div>
                <h3 class="title">
                  <aLink :toPath="newsItem.url">{{newsItem.title}}</aLink>
                </h3>
                <!-- <p class="summary">
                  {{newsItem.info}}
                </p> -->
                <p class="summary" v-html="newsItem.info">
                  
                </p>
                <div class="control">
                  <div class="btn-border js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">LISTEN</div><div>{{newsItem.duration}}</div></div>
                  <div class="btn-border js-download" v-if="'canDownload' in newsItem && newsItem.canDownload == 1" @click="download($event,newsItem.downloadMediaUrl,newsItem.fileName,newsItem.groupName)"><div class="icon">DOWNLOAD</div></div>
                  <div class="btn-border js-share" @click="share(newsItem.emailShareUrl,newsItem.facebookShareUrl,newsItem.twitterShareUrl,newsItem.weiboShareUrl,newsItem.wechatShareUrl)"><div class="icon">SHARE</div></div>
                  <div class="btn-border js-article" v-if="'programSeries' in newsItem && newsItem.programSeries.content != ''" @click="article(newsItem.columnName,newsItem.title,newsItem.date,newsItem.programSeries.content)"><div class="icon">TRANSCRIPT</div></div>
                </div>
              </dd>
            </dl>
          </div>
          <div class="picLeftW500H281-pad con" v-if="item.data && item.data.length > 0">
            <dl v-for="(newsItem,key) in item.data.slice(0,4)" :class="{'rtl':newsItem.groupName === 'ar' || newsItem.typeGroup === 'ar'}" :key="key">
              <dt>
                <div class="pic">
                  <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                  <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                </div>
                <div class="info">
                  <div class="info-con">
                    <div class="source" v-if="newsItem.fromUrl">
                      From : <aLink :toPath="newsItem.fromUrl">{{newsItem.columnName}}</aLink>
                    </div>
                    <h3 class="title">
                      <aLink :toPath="newsItem.url">{{newsItem.title}}</aLink>
                    </h3>
                  </div>
                </div>
              </dt>
              <dd>
                <p class="summary" v-html="newsItem.info">
                  
                </p>
                <div class="control">
                  <div class="btn-border js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">LISTEN</div><div>{{newsItem.duration}}</div></div>
                  <div class="btn-border js-download" v-if="'canDownload' in newsItem && newsItem.canDownload == 1" @click="download($event,newsItem.downloadMediaUrl,newsItem.fileName,newsItem.groupName)"><div class="icon">DOWNLOAD</div></div>
                  <div class="btn-border js-share" @click="shareMobile(newsItem)"><div class="icon">SHARE</div></div>
                  <div class="btn-border js-article" v-if="'programSeries' in newsItem && newsItem.programSeries.content != ''" @click="article(newsItem.columnName,newsItem.title,newsItem.date,newsItem.programSeries.content)"><div class="icon">TRANSCRIPT</div></div>
                </div>
              </dd>
            </dl>
          </div>
          <div class="picLeftW500H281-m con" v-if="item.data && item.data.length > 0">
            <dl v-for="(newsItem,key) in item.data.slice(0,4)" :class="{'rtl':newsItem.groupName === 'ar' || newsItem.typeGroup === 'ar'}" :key="key">
              <dt>
                <div class="pic">
                  <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                  <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                </div>
                <div class="info">
                  <div class="info-con">
                    <div class="source" v-if="newsItem.fromUrl">
                      From : <aLink :toPath="newsItem.fromUrl">{{newsItem.columnName}}</aLink>
                    </div>
                    <h3 class="title">
                      <aLink :toPath="newsItem.url">{{newsItem.title}}</aLink>
                    </h3>
                  </div>
                </div>
              </dt>
              <dd>
                <p class="summary" v-html="newsItem.info">
                  
                </p>
                <div class="btn-border js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">LISTEN</div><div>{{newsItem.duration}}</div></div>
                <div class="control">
                  <div class="btn-noBorder js-download" v-if="'canDownload' in newsItem && newsItem.canDownload == 1" @click="download($event,newsItem.downloadMediaUrl,newsItem.fileName,newsItem.groupName)"><div class="icon"><a>DOWNLOAD</a></div></div>
                  <div class="btn-noBorder js-share" @click="shareMobile(newsItem)"><div class="icon"><a>SHARE</a></div></div>
                  <div class="btn-noBorder js-article" v-if="'programSeries' in newsItem && newsItem.programSeries.content != ''" @click="article(newsItem.columnName,newsItem.title,newsItem.date,newsItem.programSeries.content)"><div class="icon"><a>TRANSCRIPT</a></div></div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="mod" v-if="item.styleType == 5">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
        </div>
        <div class="picTopW500H281" :style="[{backgroundImage:'url('+ (item.backgroundPicUrl) +')'}]">
          <div class="cg-mainWrapper">
            <div class="picTopW500H281-con" v-if="item.data && item.data.length > 0">
              <dl v-for="(newsItem,key) in item.data.slice(0,3*item.rows)" :key="key">
                <dt v-if="isIeState">
                  <img src="../../static/img/ie/picTopW500H281.png" alt="">
                </dt>
                <dt v-else>
                  <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                </dt>
                <dd>
                  <div class="pic">
                    <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-16-9.jpg'),error:require('../../static/img/loading/loading-16-9.jpg')}" alt="">
                    <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                  </div>
                  <div class="source" v-if="newsItem.fromUrl">
                    From : <aLink :toPath="newsItem.fromUrl">{{newsItem.columnName}}</aLink>
                  </div>
                  <div class="source" v-else></div>
                  <h3 class="title">
                    <aLink :toPath="newsItem.url">{{newsItem.title}}</aLink>
                  </h3>
                  <div class="btn-noBorder white js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">{{newsItem.duration}}</div></div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="mod" v-if="item.styleType == 6">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
        </div>
        <div class="picTopW370H370" v-if="item.data && item.data.length > 0">
          <div class="cg-mainWrapper">
            <div class="picTopW370H370-pc-con clearfloat">
              <dl v-for="(newsItem,key) in item.data.slice(0,4*item.rows)" :key="key">
                <dt>
                  <aLink :toPath="newsItem.url"><img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt=""></aLink>
                </dt>
                <dd>
                  <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                  <p>{{newsItem.info}}</p>
                  <div class="btn-noBorder js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">{{newsItem.duration}}</div></div>
                  <aLink :toPath="newsItem.url" class="more">
                    <i></i><span>MORE EPISODES</span>
                  </aLink>
                </dd>
              </dl>
            </div>
            <div class="picTopW370H370-m-con">
              <div class="news-ul">
                <div class="news-item" v-for="(newsItem,key) in item.data.slice(0,4*item.rows)" :key="key">
                  <div class="info">
                    <div class="pic">
                      <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                      <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                    </div>
                    <div class="txt">
                      <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                      <p>{{newsItem.info}}</p>
                      <div class="btn-border js-play play" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">LISTEN</div><div>{{newsItem.duration}}</div></div>
                    </div>
                  </div>
                  <div class="more">
                    <aLink :toPath="newsItem.url" class="more">
                      <i></i><span>MORE EPISODES</span>
                    </aLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mod" v-if="item.styleType == 7">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
        </div>
        <div class="picTopW275H275" v-if="item.data && item.data.length > 0">
          <div class="cg-mainWrapper">
            <div class="picTopW275H275-pc-con clearfloat js-lane-height">
              <dl v-for="(newsItem,key) in item.data.slice(0,5*item.rows)" :class="{'rtl':newsItem.groupName === 'ar'}" :key="key">
                <dt>
                  <aLink :toPath="newsItem.url"><img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt=""></aLink>
                </dt>
                <dd>
                  <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                  <p>{{newsItem.info}}</p>
                  <div class="btn-noBorder js-play play" :data-playcolumnId="newsItem.columnId" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">{{newsItem.duration}}</div></div>
                  <aLink :toPath="newsItem.url" class="more">
                    <i></i><span>MORE EPISODES</span>
                  </aLink>
                </dd>
              </dl>
            </div>
            <div class="picTopW275H275-m-con">
              <div class="news-ul">
                <div class="news-item" v-for="(newsItem,key) in item.data.slice(0,5*item.rows)" :class="{'rtl':newsItem.groupName === 'ar'}" :key="key">
                  <div class="info">
                    <div class="pic">
                      <img v-lazy="{src:newsItem.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                      <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                    </div>
                    <div class="txt">
                      <h3><aLink :toPath="newsItem.url">{{newsItem.title}}</aLink></h3>
                      <p>{{newsItem.info}}</p>
                      <div class="btn-border js-play play" :data-playcolumnId="newsItem.columnId" :data-pic="newsItem.sharePicurl" :data-showName="newsItem.shareTitle" :data-url="newsItem.mediaUrl" data-type="mp3" :data-linkUrl="newsItem.shareUrl" :data-countryCode="newsItem.countryRegionLimit" :data-groupName="newsItem.groupName" @click="play($event)"><div class="icon">LISTEN</div><div>{{newsItem.duration}}</div></div>
                    </div>
                  </div>
                  <div class="more">
                    <aLink :toPath="newsItem.url" class="more">
                      <i></i><span>MORE EPISODES</span>
                    </aLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shorts mod" v-if="item.styleType == 8">
        <div class="cg-mainWrapper">
          <h2 class="mod-title" v-if="item.moreShow == 1">
            <span>{{item.title}}</span>
            <aLink :toPath="item.linkUrl">MORE</aLink>
          </h2>
          <h2 class="mod-title" v-else>
            <span>{{item.title}}</span>
          </h2>
          <div class="swiper-container shortsSlide shorts-pc-con">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(newsItem,key) in item.data.slice(0,20)" :key="key">
                <div class="dt" :class="{'active':curShortsId === newsItem.id}">
                  <img v-lazy="{src:newsItem.videoPicurl1,loading:require('../../static/img/loading/loading-9-16.jpg'),error:require('../../static/img/loading/loading-9-16.jpg')}" alt="">
                  <aLink :toPath="newsItem.url" class="pic-mask"></aLink>
                  <p class="playBtn" @click="shortsPlay(newsItem)"><i></i></p>
                  <video class="shorts-videoPlayer" :ref="'shorts' + newsItem.id" :id="newsItem.id" v-if="newsItem.videoUrl" :src="newsItem.videoUrl" controls></video>
                </div>
                <div class="dd">
                  <h3 class="title">
                    <aLink :toPath="newsItem.url">{{newsItem.title}}</aLink>
                  </h3>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import radiogtag from '../../static/js/radio_ga'
export default {
  name: 'index',
  data () {
    return {
      isIeState:false,
      isLivePlaying:true,
      channelSlidePc:null,
      channelSlidePad:null,
      channelSlideM:null,
      channelSlidePcOptions: {
        slidesPerView: 'auto',
        // slidesPerGroup: 5,
        direction: 'horizontal',
        prevButton: ".channel-slide-pc-arrow-left", //不要忘记点
        nextButton: ".channel-slide-pc-arrow-right",
      },
      channelSlidePadOptions: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        direction: 'horizontal',
        prevButton: ".channel-slide-pad-arrow-left", //不要忘记点
        nextButton: ".channel-slide-pad-arrow-right",
      },
      channelSlideMOptions: {
        slidesPerView: 'auto',
        // slidesPerGroup: 4,
        direction: 'horizontal',
      },
      // https://radio-res.cgtn.com/radio/v1/live/detail/groupType1_id38.json
      liveXHR:{
        xhrUrl:'/api/v3/live',
        xhrParam:{
          'groupType':'1',
          'session':'8295f0a6-6804-4d61-8944-4f8d60a71cd4',
        },
      },
      lanesXHR:{
        xhrUrl:'/api/v3/classification/detail?id=25&session=8295f0a6-6804-4d61-8944-4f8d60a71cd4&groupType=1',
        xhrParam:{
          'id':'25',
          'session':'8295f0a6-6804-4d61-8944-4f8d60a71cd4',
          'groupType':'1'
        },
      },
      radioListItems:[],
      curRadioListItems:{},
      radioListPlayState:0,
      lanes:[],
      typeObjUrl:{
        ezfm:"/podcast/column",
        other:"/podcast/column",
        recommend:"/news",
        ezfmHistory:"/podcast/news",
        otherHistory:"/podcast/news",
        more:"/news",
        lane:"/laneList",
        linkUrl:'',
      },
      typeObjNum: {
        ezfm: 1,
        selection: 2,
        ezfmSelection:2,
        recommend: 3,
        more: 4,
        other: 5,
        otherSelection: 6,
        otherHistory: 5,
        ezfmHistory: 1,
      },
      categoryObjNum: {
        other: 5,
        ezfm: 1,
        5:5,
        1:1,
      },
      showsUrl:'',
      sessionCountryCode:'',
      clientWidth:document.documentElement.clientWidth,
      jetLag:0,
      curShortsId:0,
      isLoneTitleStyle:false,
      isColumnTitleScroll:false,
      textStylePad: {},
      textStyleWap: {},
    }
  },
  methods:{
    columnTitleToLink(urlStr){
      let _isDomain = urlStr.indexOf('radio.cgtn.com');
      let url = '';
      if(_isDomain != -1){
        urlStr = urlStr.split('https://radio.cgtn.com');
        url = urlStr[1];
        this.$router.push(url);
      }else if(urlStr[0] === '/'){
        url = urlStr;
        this.$router.push(url);
      }else{
        url = urlStr;
        window.open(url);
      }
    },
    isColumnTitleScrollPadFn(){
      this.$nextTick(() => {
        let parentDom = this.$refs.columnTitleParentPad.clientWidth || 0;
        let childDom = this.$refs.columnTitleChildPad.clientWidth || 0;
        if (childDom > parentDom) {
          this.curRadioListItems.nextColumnTitle = this.curRadioListItems.nextColumnTitle + ' ' + this.curRadioListItems.nextColumnTitle;
          this.textStylePad = {
            animationDuration: '10s',
          };
        } else {
          this.textStylePad = {};
        }
      });
    },
    isColumnTitleScrollWapFn(){
      this.$nextTick(() => {
        let parentDom = this.$refs.columnTitleParentWap.clientWidth || 0;
        let childDom = this.$refs.columnTitleChildWap.clientWidth || 0;
        if (childDom > parentDom) {
          this.curRadioListItems.nextColumnTitle = this.curRadioListItems.nextColumnTitle + ' ' + this.curRadioListItems.nextColumnTitle;
          this.textStyleWap = {
            animationDuration: '12s',
          };
        } else {
          this.textStyleWap = {};
        }
      });
    },
    play(event){
      var _this = this , el = $(event.currentTarget) , pages = [] , player;
      pages = _this.$parent.$children;
      for(var i=0;i<pages.length;i++){
        if($(pages[i].$el).hasClass('player')){
          pages[i].audioPlay(el,true);
        }
      }
    },
    shortsPlay(item){
      let _this = this , player = null;
      if(item.videoUrl){
        player = eval('_this.$refs.shorts' + item.id)[0];
        player.play();
      }
      _this.curShortsId = item.id;
    },
    contentListenPlayer(){
      var _this = this , videoLength , audioLength , allPlayerLength , videoPlayers , audioPlayers , allPlayers = [];
      _this.$nextTick(()=>{
        videoLength = $('video');
        audioLength = $('audio');
        allPlayerLength = videoLength.length + audioLength.length;
        console.log(allPlayerLength);
        if(allPlayerLength > 0){
          videoPlayers = document.getElementsByTagName('video');
          audioPlayers = document.getElementsByTagName('audio');
          for (let v_index = 0; v_index < videoPlayers.length; v_index++) {
            allPlayers.push(videoPlayers[v_index])
          }
          for (let a_index = 0; a_index < audioPlayers.length; a_index++) {
            allPlayers.push(audioPlayers[a_index])
          }
          function pauseAll() {
            var self = this;
            allPlayers.forEach(function(i) {
              i !== self && i.pause();
            })
          }
          allPlayers.forEach(function(i) {
            i.addEventListener("play", pauseAll.bind(i));
          })
        }
      })
    },
    shortsSlide(){
      let _this = this , slidesPerViewNum = 5 , slide = null;
      _this.$nextTick(function () {
        if(_this.clientWidth <=768){
          slidesPerViewNum = 2;
        }
        slide = new Swiper('.shortsSlide',{
          slidesPerView : slidesPerViewNum,
          slidesPerGroup : slidesPerViewNum,
          spaceBetween:18,
          pagination : '.swiper-pagination',
          paginationClickable :true,
        });
      })
    },
    radioListPlay(event,index){
      var _this = this , el = $(event.currentTarget) , pages = [] , player , _index = index;
      _this.curRadioListItems = _this.radioListItems[_index];
      if(_this.$matomo){
        _this.$matomo.trackEvent('live','livePlayClkNum',_this.curRadioListItems.columnTitle,1);
      }
      if(radiogtag){
        radiogtag.event('Live', 'livePlayClkNum', _this.curRadioListItems.columnTitle, 1)
      }
      _this.$nextTick(function(){
        _this.showsUrl = '/shows/'+_this.curRadioListItems.id;
      })
      _this.radioListPlayState = index;
      sessionStorage.setItem("radioIndex", index);
      pages = _this.$parent.$children;
      for(var i=0;i<pages.length;i++){
        if($(pages[i].$el).hasClass('player')){
          pages[i].audioPlay(el,true);
          $('.js-live-play').removeClass('pause').addClass('play');
        }
      }
      _this.liveConAutoHeight();
    },
    isIe(){
      var _this = this;
      if(!!window.ActiveXObject || "ActiveXObject" in window){//ie11及以下不包括edge
        _this.isIeState = true;
      }else{
        _this.isIeState = false;
      }
    },
    // getLiveInfo(){
    //   var _this = this , data = [] , radioList = [] , radioInfoList = [] , curWeekDay = null;
    //   curWeekDay = new Date().getDay();
    //   _this.$post(_this.liveXHR.xhrUrl,_this.liveXHR.xhrParam,_this).then(async (response)=>{
    //     data = response.data;
    //     radioList = data.data;
    //     for(var j=0;j<radioList.length;j++){
    //       var _index = j;
    //       await _this.$post('/api/v3/live/detail?session=8295f0a6-6804-4d61-8944-4f8d60a71cd4&groupType=1&id='+radioList[_index].id+'',{},_this).then(async (response)=>{
    //         var detailData = response.data.data;
    //         radioList[_index].columnTitle = detailData.programTitle;
    //         radioList[_index].programTitle = detailData.title;
    //         radioList[_index].day = detailData.day;
    //         radioList[_index].programLinkUrl = detailData.programLinkUrl;
    //         if(detailData.picurl1){
    //           radioList[_index].programUrlTwo = detailData.picurl1;
    //         }else{
    //           radioList[_index].programUrlTwo = detailData.programUrl;
    //         }
    //         radioList[_index].info = detailData.info;
    //         if('startTime' in detailData && 'stopTime' in detailData){
    //           radioList[_index].startTime = detailData.startTime;
    //           radioList[_index].stopTime = detailData.stopTime;
    //         }else{
    //           radioList[_index].startTime = '00:00';
    //           radioList[_index].stopTime = '23:59';
    //         }
    //         if(detailData.programGuide){
    //           switch (curWeekDay){ 
    //             case 0:
    //               if('week_7' in detailData.programGuide){
    //                 radioInfoList = detailData.programGuide.week_7;
    //               }else{
    //                 radioInfoList = detailData.programGuide.week_1;
    //               }
    //               break;
    //             case 1:
    //               radioInfoList = detailData.programGuide.week_1;
    //               break;
    //             case 2:
    //               radioInfoList = detailData.programGuide.week_2;
    //               break;
    //             case 3:
    //               radioInfoList = detailData.programGuide.week_3;
    //               break;
    //             case 4:
    //               radioInfoList = detailData.programGuide.week_4;
    //               break;
    //             case 5:
    //               radioInfoList = detailData.programGuide.week_5;
    //               break;
    //             case 6:
    //               if('week_6' in detailData.programGuide){
    //                 radioInfoList = detailData.programGuide.week_6;
    //               }else{
    //                 radioInfoList = detailData.programGuide.week_1;
    //               }
    //               break; 
    //           }
    //           for(var t=0;t<radioInfoList.length;t++){
    //             if(radioInfoList[t].startTime == radioList[j].startTime){
    //               if(radioInfoList[t+1]){
    //                 radioList[j].nextStartTime = radioInfoList[t+1].startTime;
    //                 radioList[j].nextStopTime = radioInfoList[t+1].stopTime;
    //                 radioList[j].nextColumnTitle = radioInfoList[t+1].programTitle;
    //                 radioList[j].nextProgramLinkUrl = radioInfoList[t+1].programLinkUrl;
    //               }else{
    //                 switch (curWeekDay+1){ 
    //                   case 0:
    //                     if('week_7' in detailData.programGuide){
    //                       radioInfoList = detailData.programGuide.week_7;
    //                     }else{
    //                       radioInfoList = detailData.programGuide.week_1;
    //                     }
    //                     break;
    //                   case 1:
    //                     radioInfoList = detailData.programGuide.week_1;
    //                     break;
    //                   case 2:
    //                     radioInfoList = detailData.programGuide.week_2;
    //                     break;
    //                   case 3:
    //                     radioInfoList = detailData.programGuide.week_3;
    //                     break;
    //                   case 4:
    //                     radioInfoList = detailData.programGuide.week_4;
    //                     break;
    //                   case 5:
    //                     radioInfoList = detailData.programGuide.week_5;
    //                     break;
    //                   case 6:
    //                     if('week_6' in detailData.programGuide){
    //                       radioInfoList = detailData.programGuide.week_6;
    //                     }else{
    //                       radioInfoList = detailData.programGuide.week_1;
    //                     }
    //                     break; 
    //                 }
    //                 radioList[j].nextStartTime = radioInfoList[0].startTime;
    //                 radioList[j].nextStopTime = radioInfoList[0].stopTime;
    //                 radioList[j].nextColumnTitle = radioInfoList[0].programTitle;
    //                 radioList[j].nextProgramLinkUrl = radioInfoList[0].programLinkUrl;
    //               }
    //             }
    //           }
    //           if(_this.jetLag != 0){
    //             radioList[j].startTime = _this.resetJetLagTime(_this.jetLag,radioList[j].startTime);
    //             radioList[j].stopTime = _this.resetJetLagTime(_this.jetLag,radioList[j].stopTime);
    //             radioList[j].nextStartTime = _this.resetJetLagTime(_this.jetLag,radioList[j].nextStartTime);
    //             radioList[j].nextStopTime = _this.resetJetLagTime(_this.jetLag,radioList[j].nextStopTime);
    //           }
    //         }
    //       })
    //     }
    //     _this.radioListItems = radioList;
    //     _this.curRadioListItems = radioList[_this.radioListPlayState];
    //     _this.showsUrl = '/shows/'+_this.curRadioListItems.id;
    //     _this.radioSlide();
    //   })
    // },
    // getLiveInfo_static(){
    //   var _this = this , data = [] , radioList = [] , radioInfoList = [] , curWeekDay = null , promiseList  = [] , timer = null;
    //   curWeekDay = new Date().getDay();
    //   _this.$get('/downapiRES/radio/v1/live/groupType1.json',{},_this).then((response)=>{
    //     data = response.data;
    //     radioList = data.data;
    //     for(let j=0;j<radioList.length;j++){
    //       promiseList.push(new Promise((resolve, reject) => {
    //         _this.$get('/downapiRES/radio/v1/live/detail/groupType1_id'+radioList[j].id+'.json',{},_this).then((response)=>{
    //           var detailData = response.data.data;
    //           radioList[j].columnTitle = detailData.programTitle;
    //           radioList[j].programTitle = detailData.title;
    //           radioList[j].day = detailData.day;
    //           radioList[j].programLinkUrl = detailData.programLinkUrl;
    //           if(detailData.picurl1){
    //             radioList[j].programUrlTwo = detailData.picurl1;
    //           }else{
    //             radioList[j].programUrlTwo = detailData.programUrl;
    //           }
    //           radioList[j].info = detailData.info;
    //           if('startTime' in detailData && 'stopTime' in detailData){
    //             radioList[j].startTime = detailData.startTime;
    //             radioList[j].stopTime = detailData.stopTime;
    //           }else{
    //             radioList[j].startTime = '00:00';
    //             radioList[j].stopTime = '23:59';
    //           }
    //           if(detailData.programGuide){
    //             switch (curWeekDay){ 
    //               case 0:
    //                 if('week_7' in detailData.programGuide){
    //                   radioInfoList = detailData.programGuide.week_7;
    //                 }else{
    //                   radioInfoList = detailData.programGuide.week_1;
    //                 }
    //                 break;
    //               case 1:
    //                 radioInfoList = detailData.programGuide.week_1;
    //                 break;
    //               case 2:
    //                 radioInfoList = detailData.programGuide.week_2;
    //                 break;
    //               case 3:
    //                 radioInfoList = detailData.programGuide.week_3;
    //                 break;
    //               case 4:
    //                 radioInfoList = detailData.programGuide.week_4;
    //                 break;
    //               case 5:
    //                 radioInfoList = detailData.programGuide.week_5;
    //                 break;
    //               case 6:
    //                 if('week_6' in detailData.programGuide){
    //                   radioInfoList = detailData.programGuide.week_6;
    //                 }else{
    //                   radioInfoList = detailData.programGuide.week_1;
    //                 }
    //                 break; 
    //             }
    //             if(radioInfoList){
    //               for(var t=0;t<radioInfoList.length;t++){
    //                 if(radioInfoList[t].startTime == radioList[j].startTime){
    //                   if(radioInfoList[t+1]){
    //                     radioList[j].nextStartTime = radioInfoList[t+1].startTime;
    //                     radioList[j].nextStopTime = radioInfoList[t+1].stopTime;
    //                     radioList[j].nextColumnTitle = radioInfoList[t+1].programTitle;
    //                     radioList[j].nextProgramLinkUrl = radioInfoList[t+1].programLinkUrl;
    //                   }else{
    //                     switch (curWeekDay+1){ 
    //                       case 0:
    //                         if('week_7' in detailData.programGuide){
    //                           radioInfoList = detailData.programGuide.week_7;
    //                         }else{
    //                           radioInfoList = detailData.programGuide.week_1;
    //                         }
    //                         break;
    //                       case 1:
    //                         radioInfoList = detailData.programGuide.week_1;
    //                         break;
    //                       case 2:
    //                         radioInfoList = detailData.programGuide.week_2;
    //                         break;
    //                       case 3:
    //                         radioInfoList = detailData.programGuide.week_3;
    //                         break;
    //                       case 4:
    //                         radioInfoList = detailData.programGuide.week_4;
    //                         break;
    //                       case 5:
    //                         radioInfoList = detailData.programGuide.week_5;
    //                         break;
    //                       case 6:
    //                         if('week_6' in detailData.programGuide){
    //                           radioInfoList = detailData.programGuide.week_6;
    //                         }else{
    //                           radioInfoList = detailData.programGuide.week_1;
    //                         }
    //                         break; 
    //                     }
    //                     radioList[j].nextStartTime = radioInfoList[0].startTime;
    //                     radioList[j].nextStopTime = radioInfoList[0].stopTime;
    //                     radioList[j].nextColumnTitle = radioInfoList[0].programTitle;
    //                     radioList[j].nextProgramLinkUrl = radioInfoList[0].programLinkUrl;
    //                   }
    //                 }
    //               }
    //             }
    //             if(_this.jetLag != 0){
    //               radioList[j].startTime = _this.resetJetLagTime(_this.jetLag,radioList[j].startTime);
    //               radioList[j].stopTime = _this.resetJetLagTime(_this.jetLag,radioList[j].stopTime);
    //               radioList[j].nextStartTime = _this.resetJetLagTime(_this.jetLag,radioList[j].nextStartTime);
    //               radioList[j].nextStopTime = _this.resetJetLagTime(_this.jetLag,radioList[j].nextStopTime);
    //             }
    //           }
    //         })
    //         resolve(radioList[j])
    //       }));
    //     }
    //     Promise.all(promiseList).then((rspList)=> {
    //       rspList.map((val)=> {
            
    //       });
    //     });
    //     _this.radioListItems = radioList;
    //     _this.curRadioListItems = radioList[_this.radioListPlayState];
    //     console.log(_this.curRadioListItems.columnTitle)
    //     _this.showsUrl = '/shows/'+_this.curRadioListItems.id;
    //     _this.radioSlide();
    //     timer = setInterval(function(){
    //       _this.$forceUpdate();
    //       if($('.index-live-bg img').length > 0){
    //         if($('.index-live-bg img').attr('src').indexOf('http') != -1){
    //           clearInterval(timer);
    //         }
    //       }
    //     },500)
    //   })
    // },
    async getLiveInfo() {
        const _this = this;
        let radioInfoList = [] , curWeekDay = new Date().getDay();
        try {
            const response = await _this.$post(_this.liveXHR.xhrUrl, _this.liveXHR.xhrParam, _this);
            let radioList = response.data.data;

            for (let j = 0; j < radioList.length; j++) {
                const _index = j;
                const detailResponse = await _this.$post(`/api/v3/live/detail?session=8295f0a6-6804-4d61-8944-4f8d60a71cd4&groupType=1&id=${radioList[_index].id}`, {}, _this);
                const detailData = detailResponse.data.data;

                Object.assign(radioList[_index], {
                    columnTitle: detailData.programTitle,
                    programTitle: detailData.title,
                    day: detailData.day,
                    programLinkUrl: detailData.programLinkUrl,
                    programUrlTwo: detailData.picurl1 || detailData.programUrl,
                    info: detailData.info,
                    startTime: detailData.startTime || '00:00',
                    stopTime: detailData.stopTime || '23:59'
                });

                radioInfoList = detailData.programGuide[`week_${curWeekDay === 0 ? 7 : curWeekDay}`] || detailData.programGuide.week_1;
                if(radioInfoList){
                  for (let t = 0; t < radioInfoList.length; t++) {
                      if (radioInfoList[t].startTime === radioList[_index].startTime) {
                          const nextProgram = radioInfoList[t + 1] || (detailData.programGuide[`week_${(curWeekDay + 1) % 7 || 1}`] || [])[0];
                          if (nextProgram) {
                              Object.assign(radioList[_index], {
                                  nextStartTime: nextProgram.startTime,
                                  nextStopTime: nextProgram.stopTime,
                                  nextColumnTitle: nextProgram.programTitle,
                                  nextProgramLinkUrl: nextProgram.programLinkUrl
                              });
                          }
                      }
                  }
                }

                if (_this.jetLag !== 0) {
                    ['startTime', 'stopTime', 'nextStartTime', 'nextStopTime'].forEach(key => {
                        radioList[_index][key] = _this.resetJetLagTime(_this.jetLag, radioList[_index][key]);
                    });
                }
            }

            _this.radioListItems = radioList;
            _this.curRadioListItems = radioList[_this.radioListPlayState];

            if(_this.clientWidth > 1560){
              if(_this.curRadioListItems.columnTitle.length > 74){
                _this.isLoneTitleStyle = true;
              }
            }else if(_this.clientWidth <= 1560 && _this.clientWidth > 1260){
              if(_this.curRadioListItems.columnTitle.length > 54){
                _this.isLoneTitleStyle = true;
              }
            }
            _this.showsUrl = `/shows/${_this.curRadioListItems.id}`;
            _this.radioSlide();
            _this.isColumnTitleScrollPadFn();
            _this.isColumnTitleScrollWapFn();

        } catch (error) {
            console.error('Error fetching live info:', error);
        }
    },
    async getLiveInfo_static() {
        const _this = this;
        let data = [], radioList = [], radioInfoList = [], curWeekDay = new Date().getDay();

        try {
            const response = await _this.$get('/downapiRES/radio/v1/live/groupType1.json');
            data = response.data;
            radioList = data.data;

            for (let j = 0; j < radioList.length; j++) {
                const detailResponse = await _this.$get(`/downapiRES/radio/v1/live/detail/groupType1_id${radioList[j].id}.json`);
                const detailData = detailResponse.data.data;

                radioList[j] = {
                    ...radioList[j],
                    columnTitle: detailData.programTitle,
                    programTitle: detailData.title,
                    day: detailData.day,
                    programLinkUrl: detailData.programLinkUrl,
                    programUrlTwo: detailData.picurl1 || detailData.programUrl,
                    info: detailData.info,
                    startTime: detailData.startTime || '00:00',
                    stopTime: detailData.stopTime || '23:59'
                };

                if (detailData.programGuide) {
                    radioInfoList = detailData.programGuide[`week_${curWeekDay === 0 ? 7 : curWeekDay}`] || detailData.programGuide.week_1;
                    if(radioInfoList){
                      for (let t = 0; t < radioInfoList.length; t++) {
                        if (radioInfoList[t].startTime === radioList[j].startTime) {
                            const nextProgram = radioInfoList[t + 1] || radioInfoList[0];
                            radioList[j].nextStartTime = nextProgram.startTime;
                            radioList[j].nextStopTime = nextProgram.stopTime;
                            radioList[j].nextColumnTitle = nextProgram.programTitle;
                            // radioList[j].nextColumnTitle = 'Live: Explore the prototype ofAvatar Hallelujah Mountains in CChina and other places in Chinaand beyond';
                            radioList[j].nextProgramLinkUrl = nextProgram.programLinkUrl;
                            break;
                        }
                      }
                    }
                    
                }

                if (_this.jetLag !== 0) {
                    ['startTime', 'stopTime', 'nextStartTime', 'nextStopTime'].forEach(key => {
                        radioList[_index][key] = _this.resetJetLagTime(_this.jetLag, radioList[_index][key]);
                    });
                }
            }

            _this.radioListItems = radioList;
            _this.curRadioListItems = radioList[_this.radioListPlayState];

            // _this.curRadioListItems.info = `"Round Table" is a premier English radio/podcast show, straight from Beijing. Hear what's buzzing on the Internet and the main streets, see the latest lifestyle trends, and feel the pulse of life in China, "Round Table" is your golden ticket. With dynamic cultural exchanges between hosts from diverse backgrounds, we take you on a journey deep into modern China.We invite you to join our conversation! roundtablepodcast@qq.com. `;

            // _this.curRadioListItems.columnTitle = 'CCCCCCCCCCCCCCCWWWWWWWWWWWWWCCCCCCCCCCCCCCCWWWW';
            // seethelatestlifestyletrendsandfeelthepulseoflifeinCCina"RoundTable"isyourswseethelatestlifestyletrendsandfeelthepulseoflifeinChina"RoundTable"isyourqw
            console.log(_this.curRadioListItems.columnTitle.length);

            // _this.curRadioListItems.columnTitle = 'see the latest lifestyle trends, and feel the pulse of life in China, "Round Table" is your golden ticket. With dynamic cultural exchanges between hosts from diverse backgrounds';

            console.log(_this.curRadioListItems.columnTitle.length);
            if(_this.clientWidth > 1560){
              if(_this.curRadioListItems.columnTitle.length > 74){
                _this.isLoneTitleStyle = true;
              }
            }else if(_this.clientWidth <= 1560 && _this.clientWidth > 1260){
              if(_this.curRadioListItems.columnTitle.length > 54){
                _this.isLoneTitleStyle = true;
              }
            }
            
            _this.showsUrl = `/shows/${_this.curRadioListItems.id}`;
            _this.radioSlide();
            _this.isColumnTitleScrollPadFn();
            _this.isColumnTitleScrollWapFn();

            const timer = setInterval(() => {
                _this.$forceUpdate();
                const imgElement = document.querySelector('.index-live-bg img');
                if (imgElement && imgElement.src.includes('http')) {
                    clearInterval(timer);
                }
            }, 500);


        } catch (error) {
            console.error('Error fetching live info:', error);
        }
    },
    radioSlide(){
      var _this = this;
      _this.$nextTick(function () {
        _this.channelSlidePc = new Swiper('.channel-slide-pc',_this.channelSlidePcOptions);
        _this.channelSlidePc.slideTo(_this.radioListPlayState);
        _this.channelSlidePad = new Swiper('.channel-slide-pad',this.channelSlidePadOptions);
        _this.channelSlidePad.slideTo(_this.radioListPlayState);
        _this.channelSlideM = new Swiper('.channel-slide-m',this.channelSlideMOptions);
        _this.channelSlideM.slideTo(_this.radioListPlayState);
        _this.liveConAutoHeight();
      })
    },
    liveConAutoHeight(){
      let _this = this;
      this.$nextTick(()=>{
        const { js_index_pad_live, index_live_control_pad, index_live_schedule_pad, index_live_nav_pad, js_index_m_live, index_live_control_m, index_live_schedule_m, index_live_nav_m } = this.$refs;

        let totalHeight = 0;

        if(_this.clientWidth <= 1260 && _this.clientWidth > 768){
          totalHeight = index_live_control_pad.clientHeight + index_live_schedule_pad.clientHeight + index_live_nav_pad.clientHeight;
          js_index_pad_live.style.height = `${totalHeight}px`;
        }else if(_this.clientWidth < 768){
          totalHeight = index_live_control_m.clientHeight + index_live_schedule_m.clientHeight + index_live_nav_m.clientHeight + 15;
          js_index_m_live.style.height = `${totalHeight}px`;
        }else{
          return false;
        }
      })
    },
    getSessionCountryCode(){
      var _this = this;
      $("meta[name='description']").attr('content','Catch the latest radio news with CGTN Radio and listen to our trending podcasts wherever you are!');
      $("meta[name='keywords']").attr('content','radio, live radio, shows, podcasts, news, radio news, world news, China news, business, politics, talk, audiobooks, arts, music, learning, Español, Français, Русский, Arabic');
      if(sessionStorage.getItem('countryCode') != null){
          _this.sessionCountryCode = sessionStorage.getItem("countryCode")
      }else{
          _this.sessionCountryCode = '';
      }
    },
    getLanes(){
      var _this = this , data = [] , lanes = [] , _url = '' , _index = 0 , data2 = [] , urlListTitle = '' , urlTitle = '' , columnUrlTitle , firstColumnData = {} , mediaName = '' , cutStart = null , cutStop = null;
      _this.$post(_this.lanesXHR.xhrUrl,_this.lanesXHR.xhrParam,_this).then(async (response)=>{
        data = response.data.data;
        lanes = data.lanes;
        for(var i=0;i<lanes.length;i++){
          // urlListTitle = lanes[i].title.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
          // urlListTitle = urlListTitle.split(' ').join('-');
          urlListTitle = _this.filterUrl(lanes[i].title)
          if('linkUrl' in lanes[i]){
            if(lanes[i].linkUrl == ''){
              lanes[i].linkUrl = '/newslist/'+urlListTitle+'/'+lanes[i].id+'';
            }else{
              lanes[i].linkUrl = lanes[i].linkUrl;
            }
          }else{
            lanes[i].linkUrl = '';
          }
          _index = i;
          if('data' in lanes[i]){
            data2 = lanes[i].data;
            for(var j=0;j<data2.length;j++){
              // urlTitle = data2[j].title.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
              // urlTitle = urlTitle.split(' ').join('-');
              if('title' in data2[j]){
                urlTitle = _this.filterUrl(data2[j].title);
                data2[j].shareTitle = data2[j].title;
              }
              if(data2[j].duration == '00:00' || data2[j].duration == ''){
                data2[j].duration = '00:00';
              }
              if(data2[j].picurl){
                data2[j].sharePicurl = data2[j].picurl;
              }
              if(data2[j].type == 'recommend' || data2[j].type == 'more'){//普通详情
                _url = _this.typeObjUrl[data2[j].type]+'/'+data2[j].type+'/'+urlTitle+'/'+data2[j].id;
                data2[j].url = _url;
                data2[j].shareUrl = 'https://radio.cgtn.com'+_url;
                data2[j].emailShareUrl = 'mailto:?subject='+data2[j].title+'&body='+data2[j].shareUrl+'';
                data2[j].facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u='+data2[j].shareUrl+'';
                data2[j].twitterShareUrl = 'https://twitter.com/intent/tweet?text=Radio%20-CGTN%20-%20'+urlTitle+'&url='+data2[j].shareUrl+'';
                if(data2[j].info != ''){
                  data2[j].info = data2[j].info.replace(/<br\/>\s*<br\/>/g, '<br\/>');
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].info+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }else{
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].title+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }
                data2[j].wechatShareUrl = data2[j].shareUrl;
                if(data2[j].mediaUrl){
                  if(data2[j].mediaUrl.indexOf('http://resezfm.meldingcloud.com') != -1){
                    data2[j].mediaUrl = data2[j].mediaUrl.replace('http://resezfm.meldingcloud.com','https://radio-res.cgtn.com');
                  }else if(data2[j].mediaUrl.indexOf('http://podcasts-cri.meldingcloud.com') != -1){
                    data2[j].mediaUrl = data2[j].mediaUrl.replace('http://podcasts-cri.meldingcloud.com','https://radio-wdsl.cgtn.com');
                  }
                  data2[j].downloadMediaUrl = data2[j].mediaUrl;
                  cutStart = data2[j].mediaUrl.lastIndexOf(".");
                  cutStop = data2[j].mediaUrl.length;
                  mediaName = data2[j].mediaUrl.substring(cutStart+1,cutStop);
                  data2[j].fileName = urlTitle+'.'+mediaName;
                  if(mediaName === 'mp4'){//视频
                    data2[j].isCanPlay = false;
                  }else{
                    data2[j].isCanPlay = true;
                  }
                }else{
                  data2[j].isCanPlay = false;
                }
                if(data2[j].countryRegionLimit && _this.sessionCountryCode){
                    if(data2[j].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                      data2[j].mediaUrl = '';
                    }
                }
              }else if(data2[j].type == 'ezfm' || data2[j].type == 'other'){//栏目列表
                _url = _this.typeObjUrl[data2[j].type]+'/'+data2[j].type+'/'+urlTitle+'/'+data2[j].id;
                data2[j].url = _url;
                // 取栏目下的第一条数据
                if('onair' in data2[j] && data2[j].onair){
                  firstColumnData = data2[j].onair;
                  if('groupName' in data2[j]){
                    data2[j].groupName = firstColumnData.groupName;
                  }else{
                    data2[j].groupName = '';
                  }
                  if(data2[j].columnPicurl1){
                    firstColumnData.picurl1 = data2[j].columnPicurl1;
                  }else{
                    firstColumnData.picurl1 = data2[j].picurl;
                  }
                  data2[j].info = firstColumnData.title;
                  data2[j].mediaUrl = firstColumnData.mediaUrl;
                  data2[j].countryRegionLimit = firstColumnData.countryRegionLimit;
                  if(data2[j].mediaUrl){
                    data2[j].mediaUrl = data2[j].mediaUrl.replace('http://resezfm.meldingcloud.com','https://radio-res.cgtn.com');
                    data2[j].mediaUrl = data2[j].mediaUrl.replace('http://podcasts-cri.meldingcloud.com','https://radio-wdsl.cgtn.com');
                  }
                  data2[j].duration = firstColumnData.duration;
                  data2[j].picurl = firstColumnData.picurl1;
                  data2[j].sharePicurl = firstColumnData.picurl;
                  data2[j].shareTitle = firstColumnData.title;
                  urlTitle = _this.filterUrl(firstColumnData.title);
                  data2[j].shareUrl = 'https://radio.cgtn.com/podcast/news/' + _this.typeObjNum[data2[j].type] + '/' + urlTitle + '/' + firstColumnData.id;
                  if(data2[j].countryRegionLimit && _this.sessionCountryCode){
                      if(data2[j].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                        data2[j].mediaUrl = '';
                      }
                  }
                }
              }else if(data2[j].type == 'ezfmHistory' || data2[j].type == 'otherHistory'){//栏目详情
                _url = _this.typeObjUrl[data2[j].type]+'/'+_this.typeObjNum[data2[j].type]+'/'+urlTitle+'/'+data2[j].id;
                data2[j].url = _url;
                data2[j].shareUrl = 'https://radio.cgtn.com'+_url;
                data2[j].emailShareUrl = 'mailto:?subject='+data2[j].title+'&body='+data2[j].shareUrl+'';
                data2[j].facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u='+data2[j].shareUrl+'';
                data2[j].twitterShareUrl = 'https://twitter.com/intent/tweet?text=Radio%20-CGTN%20-%20'+urlTitle+'&url='+data2[j].shareUrl+'';
                if(data2[j].info != ''){
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].info+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }else{
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].title+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }
                data2[j].wechatShareUrl = data2[j].shareUrl;
                if('groupName' in data2[j]){
                  data2[j].groupName = data2[j].groupName;
                }else{
                  data2[j].groupName = '';
                }
                if(data2[j].columnId && data2[j].columnName){
                  // columnUrlTitle = data2[j].columnName.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
                  // columnUrlTitle = columnUrlTitle.split(' ').join('-');
                  columnUrlTitle = _this.filterUrl(data2[j].columnName);
                  data2[j].fromUrl = _this.typeObjUrl[data2[j].columnType]+'/'+data2[j].columnType+'/'+columnUrlTitle+'/'+data2[j].columnId;
                  data2[j].shareFromUrl = 'https://radio.cgtn.com'+_this.typeObjUrl[data2[j].columnType]+'/'+data2[j].columnType+'/'+columnUrlTitle+'/'+data2[j].columnId;
                }
                if(data2[j].mediaUrl){
                  if(data2[j].mediaUrl.indexOf('http://resezfm.meldingcloud.com') != -1){
                    data2[j].mediaUrl = data2[j].mediaUrl.replace('http://resezfm.meldingcloud.com','https://radio-res.cgtn.com');
                  }else if(data2[j].mediaUrl.indexOf('http://podcasts-cri.meldingcloud.com') != -1){
                    data2[j].mediaUrl = data2[j].mediaUrl.replace('http://podcasts-cri.meldingcloud.com','https://radio-wdsl.cgtn.com');
                  }
                  data2[j].downloadMediaUrl = data2[j].mediaUrl;
                  cutStart = data2[j].mediaUrl.lastIndexOf(".");
                  cutStop = data2[j].mediaUrl.length;
                  mediaName = data2[j].mediaUrl.substring(cutStart+1,cutStop);
                  data2[j].fileName = urlTitle+'.'+mediaName;
                  if(mediaName === 'mp4'){//视频
                    data2[j].isCanPlay = false;
                  }else{
                    data2[j].isCanPlay = true;
                  }
                }else{
                  data2[j].isCanPlay = false;
                }
                if(data2[j].countryRegionLimit && _this.sessionCountryCode){
                    if(data2[j].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                      data2[j].mediaUrl = '';
                    }
                }
              }else if(data2[j].type == 'linkUrl'){
                _url = data2[j].linkUrl;
                data2[j].url = _url;
              }else{
                data2[j].url = data2[j].id;
              }
            }
          }
        }
        _this.lanes = lanes;
        _this.shortsSlide();
        _this.contentListenPlayer();
        if(_this.clientWidth > 768){
          setTimeout(function(){
            _this.itemHeight();
          },200)
          
        }
      })
    },
    getLanes_static(){
      var _this = this , data = [] , lanes = [] , _url = '' , _index = 0 , data2 = [] , urlListTitle = '' , urlTitle = '' , columnUrlTitle , firstColumnData = {} , mediaName = '' , cutStart = null , cutStop = null;
      _this.$get('/downapiRES/radio/v1/classification/detail/groupType1_id25.json',{},_this).then(async (response)=>{
        data = response.data.data;
        lanes = data.lanes;
        console.log(lanes)
        for(var i=0;i<lanes.length;i++){
          // urlListTitle = lanes[i].title.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
          // urlListTitle = urlListTitle.split(' ').join('-');
          urlListTitle = _this.filterUrl(lanes[i].title)
          if('linkUrl' in lanes[i]){
            if(lanes[i].linkUrl == ''){
              lanes[i].linkUrl = '/newslist/'+urlListTitle+'/'+lanes[i].id+'';
            }else{
              lanes[i].linkUrl = lanes[i].linkUrl;
            }
          }else{
            lanes[i].linkUrl = '';
          }
          _index = i;
          if('data' in lanes[i]){
            data2 = lanes[i].data;
            for(var j=0;j<data2.length;j++){
              // urlTitle = data2[j].title.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
              // urlTitle = urlTitle.split(' ').join('-');
              if('title' in data2[j]){
                urlTitle = _this.filterUrl(data2[j].title);
                data2[j].shareTitle = data2[j].title;
              }
              if(data2[j].duration == '00:00' || data2[j].duration == ''){
                data2[j].duration = '00:00';
              }
              if(data2[j].picurl){
                data2[j].sharePicurl = data2[j].picurl;
              }
              if(data2[j].type == 'recommend' || data2[j].type == 'more'){//普通详情
                _url = _this.typeObjUrl[data2[j].type]+'/'+data2[j].type+'/'+urlTitle+'/'+data2[j].id;
                data2[j].url = _url;
                data2[j].shareUrl = 'https://radio.cgtn.com'+_url;
                data2[j].emailShareUrl = 'mailto:?subject='+data2[j].title+'&body='+data2[j].shareUrl+'';
                data2[j].facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u='+data2[j].shareUrl+'';
                data2[j].twitterShareUrl = 'https://twitter.com/intent/tweet?text=Radio%20-CGTN%20-%20'+urlTitle+'&url='+data2[j].shareUrl+'';
                if(data2[j].info != ''){
                  data2[j].info = data2[j].info.replace(/<br\/>\s*<br\/>/g, '<br\/>');
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].info+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }else{
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].title+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }
                data2[j].wechatShareUrl = data2[j].shareUrl;
                if(data2[j].mediaUrl){
                  data2[j].downloadMediaUrl = data2[j].mediaUrl
                  cutStart = data2[j].mediaUrl.lastIndexOf(".");
                  cutStop = data2[j].mediaUrl.length;
                  mediaName = data2[j].mediaUrl.substring(cutStart+1,cutStop);
                  data2[j].fileName = urlTitle+'.'+mediaName;
                  if(mediaName === 'mp4'){//视频
                    data2[j].isCanPlay = false;
                  }else{
                    data2[j].isCanPlay = true;
                  }
                }else{
                  data2[j].isCanPlay = false;
                }
                if(data2[j].countryRegionLimit && _this.sessionCountryCode){
                    if(data2[j].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                      data2[j].mediaUrl = '';
                    }
                }
              }else if(data2[j].type == 'ezfm' || data2[j].type == 'other'){//栏目列表
                _url = _this.typeObjUrl[data2[j].type]+'/'+data2[j].type+'/'+urlTitle+'/'+data2[j].id;
                data2[j].url = _url;
                // 取栏目下的第一条数据
                if('onair' in data2[j] && data2[j].onair){
                  firstColumnData = data2[j].onair;
                  if('groupName' in data2[j]){
                    data2[j].groupName = firstColumnData.groupName;
                  }else{
                    data2[j].groupName = '';
                  }
                  if(data2[j].columnPicurl1){
                    firstColumnData.picurl1 = data2[j].columnPicurl1;
                  }else{
                    firstColumnData.picurl1 = data2[j].picurl;
                  }
                  data2[j].info = firstColumnData.title;
                  data2[j].mediaUrl = firstColumnData.mediaUrl;
                  data2[j].duration = firstColumnData.duration;
                  data2[j].picurl = firstColumnData.picurl1;
                  data2[j].sharePicurl = firstColumnData.picurl;
                  data2[j].shareTitle = firstColumnData.title;
                  urlTitle = _this.filterUrl(firstColumnData.title);
                  data2[j].shareUrl = 'https://radio.cgtn.com/podcast/news/' + _this.typeObjNum[data2[j].type] + '/' + urlTitle + '/' + firstColumnData.id;
                  data2[j].countryRegionLimit = firstColumnData.countryRegionLimit;
                  if(data2[j].countryRegionLimit && _this.sessionCountryCode){
                      if(data2[j].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                        data2[j].mediaUrl = '';
                      }
                  }
                }
              }else if(data2[j].type == 'ezfmHistory' || data2[j].type == 'otherHistory'){//栏目详情
                _url = _this.typeObjUrl[data2[j].type]+'/'+_this.typeObjNum[data2[j].type]+'/'+urlTitle+'/'+data2[j].id;
                data2[j].url = _url;
                data2[j].shareUrl = 'https://radio.cgtn.com'+_url;
                data2[j].emailShareUrl = 'mailto:?subject='+data2[j].title+'&body='+data2[j].shareUrl+'';
                data2[j].facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?display=popup&app_id=723054267828678&u='+data2[j].shareUrl+'';
                data2[j].twitterShareUrl = 'https://twitter.com/intent/tweet?text=Radio%20-CGTN%20-%20'+urlTitle+'&url='+data2[j].shareUrl+'';
                if(data2[j].info != ''){
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].info+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }else{
                  data2[j].weiboShareUrl = 'http://service.weibo.com/share/share.php?title='+data2[j].title+'&pic='+data2[j].picurl+'&url='+data2[j].shareUrl+'';
                }
                data2[j].wechatShareUrl = data2[j].shareUrl;
                if('groupName' in data2[j]){
                  data2[j].groupName = data2[j].groupName;
                }else{
                  data2[j].groupName = '';
                }
                if(data2[j].columnId && data2[j].columnName){
                  // columnUrlTitle = data2[j].columnName.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
                  // columnUrlTitle = columnUrlTitle.split(' ').join('-');
                  columnUrlTitle = _this.filterUrl(data2[j].columnName);
                  data2[j].fromUrl = _this.typeObjUrl[data2[j].columnType]+'/'+data2[j].columnType+'/'+columnUrlTitle+'/'+data2[j].columnId;
                  data2[j].shareFromUrl = 'https://radio.cgtn.com'+_this.typeObjUrl[data2[j].columnType]+'/'+data2[j].columnType+'/'+columnUrlTitle+'/'+data2[j].columnId;
                }
                if(data2[j].mediaUrl){
                  data2[j].downloadMediaUrl = data2[j].mediaUrl;
                  cutStart = data2[j].mediaUrl.lastIndexOf(".");
                  cutStop = data2[j].mediaUrl.length;
                  mediaName = data2[j].mediaUrl.substring(cutStart+1,cutStop);
                  data2[j].fileName = urlTitle+'.'+mediaName;
                  if(mediaName === 'mp4'){//视频
                    data2[j].isCanPlay = false;
                  }else{
                    data2[j].isCanPlay = true;
                  }
                }else{
                  data2[j].isCanPlay = false;
                }
                if(data2[j].countryRegionLimit && _this.sessionCountryCode){
                    if(data2[j].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                      data2[j].mediaUrl = '';
                    }
                }
              }else if(data2[j].type == 'linkUrl'){
                _url = data2[j].linkUrl;
                data2[j].url = _url;
              }else{
                data2[j].url = data2[j].id;
              }
            }
          }
        }
        _this.lanes = lanes;
        console.log(_this.lanes);
        _this.shortsSlide();
        _this.contentListenPlayer();
        if(_this.clientWidth > 768){
          setTimeout(function(){
            _this.itemHeight();
          },200)
        }
      })
    },
    itemHeight(paramEl){
      var _this = this , modEl , el , flagNum;
      _this.$nextTick(function(){
        modEl = $('.js-lane-height');
        for(var i=0;i<modEl.length;i++){
          if(modEl.eq(i).hasClass('index-fivePic-con')){
            _this.clientWidth <= 1260 ? flagNum = 4 : flagNum = 5;
          }else if(modEl.eq(i).hasClass('index-fourPic-con')){
            _this.clientWidth <= 1260 ? flagNum = 2 : flagNum = 4;
          }else if(modEl.eq(i).hasClass('picTopW275H275-pc-con')){
            _this.clientWidth <= 1260 ? flagNum = 4 : flagNum = 5;
          }else if(modEl.eq(i).hasClass('picTopW370H370-pc-con')){
            _this.clientWidth <= 1260 ? flagNum = 4 : flagNum = 4;
          }
          el = modEl.eq(i).find('dl');
          var fivePicHeightArr = [];
          var fivePicEltArr = [];
          if(el.length > 0){
            for(var fivePicIndexOne=1;fivePicIndexOne<=el.length;fivePicIndexOne++){
              if(fivePicIndexOne % flagNum == 1){
                var a = [];
                var b = [];
                fivePicHeightArr.push(a);
                fivePicEltArr.push(b);
              }
              a.push(el.eq(fivePicIndexOne-1).find('dd h3').height());
              b.push(el.eq(fivePicIndexOne-1));
            }
            if(fivePicHeightArr){
              for(var fivePicIndexTwo=0;fivePicIndexTwo<fivePicHeightArr.length;fivePicIndexTwo++){
                if(fivePicEltArr){
                  for(var fivePicIndexThree=0;fivePicIndexThree<fivePicEltArr[fivePicIndexTwo].length;fivePicIndexThree++){
                    fivePicEltArr[fivePicIndexTwo][fivePicIndexThree].find('dd h3').css('height',Math.max.apply(null,fivePicHeightArr[fivePicIndexTwo])+'px')
                  }
                }
              }
            }
          }
        }
      })
    },
    share(emailUrl,facebookUrl,twitterUrl,weiboUrl,wechatUrl){
      var _this = this;
      _this.$shareDialog.showShareDialog({
        title: 'Share',
        link:{
          facebook:facebookUrl,
          twitter:twitterUrl,
          weibo:weiboUrl,
          weixin:wechatUrl,
          email:emailUrl,
        }
      })
    },
    // 手机端分享
    async shareMobile(item) {
      console.log(item);
      let titleStr = item.title;
      let indexUrl = item.shareUrl;
      let descStr = item.info.replace(/<br>/g,' ');
      // 先判断浏览器是否支持 Web Share API
      if (!navigator.share) {
        this.share(item.emailShareUrl,item.facebookShareUrl,item.twitterShareUrl,item.weiboShareUrl,item.wechatShareUrl)
        return;
      }

      try {
        await navigator.share({
          title: titleStr,
          text: descStr,
          url: indexUrl 
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('分享失败', err);
        }
      }
    },
    article(columnTitle,title,date,content){
      var _this = this , _columnTitle = columnTitle , _title = title , _date = date , _content = content;
      _this.$articleDialog.showArticleDialog({
        columnTitle:_columnTitle,
        title: _title,
        date: _date,
        content: _content,
      })
    },
    getSession(){
      var _this = this ,  _index = 0;
      if(sessionStorage.getItem('radioIndex') != null){
        _index = sessionStorage.getItem("radioIndex")
        _this.radioListPlayState = _index;
      }else{
        _this.radioListPlayState = 0;
      }
    },
    reqInit(){
      var _this = this;
      if(_this.isStaticRequest){
        console.log('静态')
        _this.getLiveInfo_static();
        _this.getLanes_static();
      }else{
        console.log('动态')
        _this.getLiveInfo();
        _this.getLanes();
      }
    },
  },
  created(){
    // this.getSession();
    // this.isIe();
    // this.reqInit();
  },
  mounted(){
    
  },
  activated(){
    this.jetLag = new Date().getTimezoneOffset() / -60;
    this.jetLag = parseInt(this.jetLag);
    this.jetLag = 8 - this.jetLag;
    this.getSession();
    this.getSessionCountryCode();
    this.isIe();
    this.reqInit();
  },
}
</script>


<style scoped lang="scss">
.index-pc-live{
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  background-color: #666;
  .index-live-bg{
    width: 100%;
    height: 100%;
    -webkit-filter: blur(100px);
    -moz-filter: blur(100px);
    -o-filter: blur(100px);
    -ms-filter: blur(100px);
    filter: blur(100px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #dddddd;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .index-live-bgCurrent{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: #000;
    opacity: .1;
  }
  .index-live-con{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    .index-live-control{
      height: 280px;
      position: relative;
      .toLive{
        width: 40px;
        height: 40px;
        position: absolute;
        top: 30px;
        right: 0px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        a{
          width: 100%;
          height: 100%;
          display: block;
          background: url('/static/img/index-live-share-btn.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .index-live-pic{
        width: 280px;
        height: 100%;
        overflow: hidden;
        background-color: #000;
        img{
          width: 100%;
        }
      }
      .index-live-current-info{
        width: 785px;
        height: 100%;
        background: url('/static/img/index-live-infoBg.png') no-repeat top left;
        background-size: 52px 100%;
        .top{
          overflow: hidden;
          clear: both;
          padding: 40px 50px 0 20px;
          .js-play{
            width: 118px;
            height: 118px;
            cursor: pointer;
            float: left;
            &.play{
              background: url('/static/img/onAir-playBtn.png') no-repeat center center;
              background-size: 116px 118px;
            }
            &.pause{
              background: url('/static/img/onAir-pauseBtn.png') no-repeat center center;
              background-size: 116px 118px;
            }
          }
          .onAir{
            color: #ffffff;
            float: left;
            overflow: hidden;
            max-width: 590px;
            .onAir-time{
              font-size: 20px;
              line-height: 30px;
              font-family: HelveticaLTPro-Bold;
              span{
                font-size: 16px;
                font-family: HelveticaLTPro-Roman;
                font-weight: normal;
              }
            }
            .onAir-name{
              font-size: 30px;
              margin-top: 12px;
              line-height: 35px;
              max-height: 70px;
              overflow: hidden;
              font-weight: 400;
              word-break: break-word;
              a{
                font-size: 32px;
                line-height: 35px;
                max-height: 70px;
                overflow: hidden;
                font-weight: 400;
                color: #ffffff;
                display: block;
              }
              &.loneTitle{
                font-size: 24px;
                max-height: 105px;
                a{
                  font-size: 24px;
                  max-height: 105px;
                }
              }
            }
          }
        }
        .bottom{
          padding: 0 50px 0 51px;
          overflow: hidden;
          .onAir-summary{
            font-size: 16px;
            line-height: 24px;
            color: #ffffff;
            font-family: HelveticaLTPro-Roman;
            // max-height: 72px;
            max-height: 120px;
            overflow: hidden;
            &.loneTitle{
              line-height: 22px;
              max-height: 66px;
              margin-top: 10px;
            }
          }
        }
      }
      .index-live-next-info{
        width: 256px;
        height: 100%;
        background: url('/static/img/index-live-infoBg.png') no-repeat top left;
        background-size: 52px 100%;
        padding: 0 18px;
        .next{
          color: #ffffff;
          .next-time{
            margin-top: 88px;
            font-size: 20px;
            line-height: 30px;
            font-family: HelveticaLTPro-Bold;
            span{
              font-size: 16px;
              font-family: HelveticaLTPro-Roman;
              font-weight: normal;
            }
          }
          .next-name{
            font-size: 16px;
            line-height: 22px;
            margin-top: 33px;
            max-height: 110px;
            overflow: hidden;
            a{
              color: #ffffff;
            }
          }
        }
      }
      .index-live-schedule{
        width: 215px;
        height: 100%;
        background: url('/static/img/index-live-infoBg.png') no-repeat top left;
        background-size: 52px 100%;
        padding: 0 18px;
        .clock{
          margin-left: -8px;
          margin-top: 81px;
          .clock-icon{
            width: 40px;
            height: 40px;
            background: url('/static/img/icon-clock.png') no-repeat;
            background-size: 100% 100%;
            display: block;
          }
        }
        .schedule-to{
          color: #ffffff;
          text-decoration: underline;
          font-size: 20px;
          line-height: 28px;
          margin-top: 33px;
          display: block;
        }
      }
    }
    .index-live-nav{
      height: 120px;
      background: url('/static/img/index-live-nav-bg.png') no-repeat;
      background-size: 100% 100%;
      .channel-slide-pc{
        width: 100%;
        padding-left: 15px;
        .swiper-slide{
          height: 120px;
          width: 290px;
          // margin-right: 10px;
          dl{
            padding-top: 20px;
            height: 100%;
            dt{
              float: left;
              overflow: hidden;
              width: 80px;
              height: 80px;
              box-shadow: 0 0 15px #fff;
              border-radius: 50%;
              background-color: #fbfbfb;
              position: relative;
              cursor: pointer;
              img{
                width: 70px;
                height: 70px;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                z-index: 1;
              }
              .pic-mask{
                width: 70px;
                height: 70px;
                border-radius: 50%;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                box-shadow: inset 0px 0px 15px 0px rgba(0,0,0,.5);
                z-index: 2;
              }
              .playingGif{
                width: 70px;
                height: 70px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                z-index: 3;
                display: none;
                background-color: rgba(0,0,0,.5);
                border-radius: 50%;
                img{
                  width: 60px;
                  height: auto;
                  position: absolute;
                  top: -10px;
                  left: 50%;
                  transform: translateX(-50%);
                }
              }
              &.current{
                .playingGif{
                  display: block;
                }
              }
            }
            dd{
              float: left;
              margin-top: 15px;
              margin-left: 12px;
              color: #333333;
              width: 198px;
              h3{
                font-family: HelveticaLTPro-Bold;
                font-size: 20px;
                line-height: 28px;
                font-weight: 400;
                max-height: 56px;
                overflow: hidden;
              }
              p{
                font-family: HelveticaLTPro-Roman;
                font-size: 16px;
                line-height: 20px;
                max-width: 156px;
                max-height: 20px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              }
            }
          }
        }
        .channel-slide-pc-arrows-current{
          position: absolute;
          width: 50px;
          height: 100%;
          top: 0;
          right: 0;
          z-index: 2;
          -webkit-filter: blur(10px);
          -moz-filter: blur(10px);
          -o-filter: blur(10px);
          -ms-filter: blur(10px);
          filter: blur(10px);
          background:rgba(255,255,255,.2);
        }
        .channel-slide-pc-arrows{
          position: absolute;
          width: 50px;
          height: 100%;
          right: 0;
          top: 0;
          z-index: 3;
          padding-top: 24px;
          .channel-slide-pc-arrow{
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: url('/static/img/arrow-left.png') no-repeat center center;
            background-size: 20px 15.93px;
            background-color: rgba(0,0,0,1);
            margin: auto;
            cursor: pointer;
            &.channel-slide-pc-arrow-right{
              transform:rotate(180deg);
              -ms-transform:rotate(180deg); 	/* IE 9 */
              -moz-transform:rotate(180deg); 	/* Firefox */
              -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
              -o-transform:rotate(180deg); 	/* Opera */
            }
            &.swiper-button-disabled{
              opacity: .35;
              cursor: auto;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
}
@supports (-webkit-backdrop-filter: brightness(40%) blur(100px)) or (backdrop-filter: brightness(40%) blur(100px)){
  /* 支持 backdrop-filter 时应用的效果，记得把一些属性覆盖掉 */
  .index-pc-live{
    background-color: transparent;
  }
  .index-live-bg {
    -webkit-backdrop-filter: brightness(40%) blur(100px);
    backdrop-filter: brightness(40%) blur(100px);
  }
}
.index-pad-live , .index-m-live{display: none;}
@media screen and (max-width: 1560px) and (min-width: 1261px) {
  .index-pc-live{
    height: 445px;
    .index-live-con{
      height: 325px;
      .index-live-control{
        height: 325px;
        position: relative;
        .index-live-pic{
          width: 325px;
        }
        .index-live-current-info{
          width: 620px;
          .top{
            padding: 70px 50px 0 10px;
            .onAir{
              max-width: 440px;
              .onAir-name{
                &.loneTitle{
                  font-size: 22px;
                  line-height: 24px;
                  max-height: 72px;
                  a{
                    font-size: 22px;
                    line-height: 24px;
                    max-height: 72px;
                  }
                }
              }
            }
          }
          .bottom{
            padding: 0 50px 0 41px;
            overflow: hidden;
            .onAir-summary{
              font-size: 16px;
              line-height: 22px;
              color: #ffffff;
              font-family: HelveticaLTPro-Roman;
              // max-height: 72px;
              max-height: 132px;
              overflow: hidden;
            }
          }
        }
        .index-live-next-info{
          width: 203px;
          padding: 0 10px;
          .next{
            color: #ffffff;
            .next-time{
              margin-top: 118px;
            }
            .next-name{
              max-height: 132px;
            }
          }
        }
        .index-live-schedule{
          width: 100px;
          padding: 0 10px;
          .clock{
            margin-top: 111px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1260px) and (min-width: 769px) {
  @keyframes loopText {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  .index-pad-live{
    display: block;
    position: relative;
    width: 100%;
    height: 520px;
    overflow: hidden;
    background-color: #666;
    .index-live-bg{
      width: 100%;
      height: 100%;
      -webkit-filter: blur(100px);
      -moz-filter: blur(100px);
      -o-filter: blur(100px);
      -ms-filter: blur(100px);
      filter: blur(100px);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: #dddddd;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .index-live-bgCurrent{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      background-color: #000;
      opacity: .1;
    }
    .index-live-con{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
      .index-live-control{
        overflow: hidden;
        padding: 24px;
        position: relative;
        .toLive{
          width: 40px;
          height: 40px;
          position: absolute;
          top: 30px;
          right: 8px;
          font-size: 16px;
          color: #fff;
          cursor: pointer;
          a{
            width: 100%;
            height: 100%;
            display: block;
            background: url('/static/img/index-live-share-btn.png') no-repeat center center;
            background-size: 100% 100%;
          }
        }
        .index-live-pic{
          width: 240px;
          height: 240px;
          border-radius: 8px;
          background-color: #000000;
          box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.5);
          float: left;
          img{
            width: 100%;
            border-radius: 5px;
          }
        }
        .index-live-info{
          float: left;
          color: #ffffff;
          width: 480px;
          .top{
            overflow: hidden;
            clear: both;
            .js-play{
              width: 116px;
              height: 116px;
              background: url('/static/img/onAir-playBtn.png') no-repeat center center;
              background-size: 116px 118px;
              cursor: pointer;
              float: left;
              &.play{
                background: url('/static/img/onAir-playBtn.png') no-repeat center center;
                background-size: 114px 116px;
              }
              &.pause{
                background: url('/static/img/onAir-pauseBtn.png') no-repeat center center;
                background-size: 114px 116px;
              }
            }
            .onAir{
              float: left;
              overflow: hidden;
              max-width: 350px;
              .onAir-time{
                font-size: 20px;
                line-height: 30px;
                font-family: HelveticaLTPro-Bold;
                margin-top: 10px;
                span{
                  font-size: 16px;
                  font-family: HelveticaLTPro-Roman;
                  font-weight: normal;
                }
              }
              .onAir-name{
                font-size: 22px;
                line-height: 28px;
                a{
                  font-size: 22px;
                  line-height: 28px;
                  color: #ffffff;
                }
              }
            }
          }
          .bottom{
            padding: 0 31px 0 31px;
            .onAir-summary{
              font-size: 16px;
              line-height: 24px;
              color: #ffffff;
              font-family: HelveticaLTPro-Roman;
            }
          }
        }
      }
      .index-live-schedule{
        .wrapper{
          height: 72px;
          padding: 23px 24px 0 72px;
          .clock{
            float: left;
            a{
              padding-left: 30px;
              display: block;
              background: url('/static/img/icon-clock-black.png') no-repeat;
              background-size: 25px 24px;
              font-size: 20px;
              line-height: 26px;
              text-decoration: underline;
            }
          }
          .index-live-next-info{
            float: left;
            margin-left: 104px;
            h3{
              color: #ffffff;
              font-size: 20px;
              line-height: 26px;
              font-family: HelveticaLTPro-Bold;
              font-weight: 400;
              &.time{
                float: left;
              }
              &.name{
                float: left;
                margin-left: 10px;
                width: 298px;
                height: 26px;
                overflow: hidden;
                white-space: nowrap;
                span{
                  color: #ffffff;
                  font-size: 20px;
                  line-height: 26px;
                  font-family: HelveticaLTPro-Bold;
                  font-weight: 400;
                  display: inline-block;
                  // padding-left: 0%;
                  animation: loopText linear infinite;
                  &.hoverStyle{
                    cursor: pointer;
                  }
                }
              }
              span{
                font-size: 16px;
                font-family: HelveticaLTPro-Roman;
                font-weight: normal;
              }
            }
          }
        }
      }
      .index-live-nav{
        height: 160px;
        background: url('/static/img/index-live-nav-bg.png') no-repeat;
        background-size: 100% 100%;
        .cg-mainWrapper{
          position: relative;
          width: 736px !important;
          .channel-slide-pad{
            width: 676px;
            .swiper-slide{
              height: 160px;
              dl{
                height: 100%;
                dt{
                  overflow: hidden;
                  width: 70px;
                  height: 70px;
                  box-shadow: 0 0 15px #fff;
                  border-radius: 50%;
                  background-color: #fbfbfb;
                  position: relative;
                  margin: 16px auto 0;
                  cursor: pointer;
                  img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    z-index: 1;
                  }
                  .pic-mask{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    box-shadow: inset 0px 0px 15px 0px rgba(0,0,0,.5);
                    z-index: 2;
                  }
                  .playingGif{
                    width: 70px;
                    height: 70px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    z-index: 3;
                    display: none;
                    background-color: rgba(0,0,0,.5);
                    border-radius: 50%;
                    img{
                      width: 60px;
                      height: auto;
                      position: absolute;
                      top: -10px;
                      left: 50%;
                      transform: translateX(-50%);
                    }
                  }
                  &.current{
                    .playingGif{
                      display: block;
                    }
                  }
                }
                dd{
                  color: #333333;
                  text-align: center;
                  margin-top: 8px;
                  h3{
                    font-family: HelveticaLTPro-Bold;
                    font-size: 16px;
                    line-height: 20px;
                    max-height: 20px;
                    font-weight: 400;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  p{
                    font-family: HelveticaLTPro-Roman;
                    font-size: 16px;
                    line-height: 20px;
                    max-height: 40px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }
            }
          }
          .channel-slide-pad-arrow{
            position: absolute;
            top: 30px;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: url('/static/img/arrow-left.png') no-repeat center center;
            background-size: 15px 11.94px;
            background-color: rgba(0,0,0,1);
            margin: auto;
            cursor: pointer;
            &.channel-slide-pad-arrow-left{
              left: 0;
            }
            &.channel-slide-pad-arrow-right{
              right: 0;
              transform:rotate(180deg);
              -ms-transform:rotate(180deg); 	/* IE 9 */
              -moz-transform:rotate(180deg); 	/* Firefox */
              -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
              -o-transform:rotate(180deg); 	/* Opera */
            }
            &.swiper-button-disabled{
              opacity: .35;
              cursor: auto;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
  .index-pc-live{
    display: none;
  }
  @supports (-webkit-backdrop-filter: brightness(20%) blur(100px)) or (backdrop-filter: brightness(20%) blur(100px)){
  /* 支持 backdrop-filter 时应用的效果，记得把一些属性覆盖掉 */
    .index-pad-live{
      background-color: transparent;
    }
    .index-live-bg {
      -webkit-backdrop-filter: brightness(20%) blur(100px);
      backdrop-filter: brightness(20%) blur(100px);
    }
  }
}
@media screen and (max-width: 768px) {
  @keyframes loopText {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  .index-pc-live{
    display: none;
  }
  .index-m-live{
    display: block;
    position: relative;
    width: 100%;
    // height: 29.83rem;
    height: 32.49rem;
    overflow: hidden;
    background-color: #666;
    .index-live-bg{
      width: 100%;
      height: 100%;
      -webkit-filter: blur(5.56rem);
      -moz-filter: blur(5.56rem);
      -o-filter: blur(5.56rem);
      -ms-filter: blur(5.56rem);
      filter: blur(5.56rem);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: #dddddd;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .index-live-bgCurrent{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      background-color: #000;
      opacity: .1;
    }
    .index-live-con{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
      .toLive{
        width: 1.75rem;
        height: 1.75rem;
        position: absolute;
        top: .5rem;
        right: 1.11rem;
        font-size: 1rem;
        color: #fff;
        cursor: pointer;
        a{
          width: 100%;
          height: 100%;
          display: block;
          background: url('/static/img/index-live-share-btn.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .index-live-control{
        overflow: hidden;
        .top{
          overflow: hidden;
          clear: both;
          padding: 0 1.11rem;
          margin-top: 1.11rem;
          .index-live-pic{
            width: 8.89rem;
            height: 8.89rem;
            border-radius: 8px;
            background-color: #000000;
            box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.5);
            float: left;
            img{
              width: 100%;
              border-radius: .28rem;
            }
          }
          .index-live-info{
            float: left;
            color: #ffffff;
            margin-top: .4rem;
            .js-play{
              width: 5.44rem;
              height: 5.44rem;
              cursor: pointer;
              float: left;
              &.play{
                background: url('/static/img/onAir-playBtn.png') no-repeat center center;
                background-size: 5.33rem 5.44rem;
              }
              &.pause{
                background: url('/static/img/onAir-pauseBtn.png') no-repeat center center;
                background-size: 5.33rem 5.44rem;
              }
            }
            .onAir{
              float: left;
              overflow: hidden;
              max-width: 10rem;
              .onAir-time{
                font-size: .83rem;
                line-height: 1.33rem;
                font-family: HelveticaLTPro-Bold;
                margin-top: .56rem;
                span{
                  font-size: .67rem;
                  font-family: HelveticaLTPro-Roman;
                  font-weight: normal;
                }
              }
              .onAir-name{
                font-size: 1rem;
                line-height: 1.2rem;
                a{
                  font-size: 1rem;
                  line-height: 1.2rem;
                  color: #ffffff;
                }
              }
            }
          }
        }
        .bottom{
          margin-top: 1.11rem;
          padding: 0 1.11rem;
          .onAir-summary{
            font-size: .89rem;
            line-height: 1.2rem;
            color: #ffffff;
            font-family: HelveticaLTPro-Roman;
          }
        }
      }
      .index-live-schedule{
        background-color: rgba(0,0,0,.1);
        margin-top: 15px;
        .wrapper{
          height: 2.67rem;
          padding: 0 1.11rem;
          overflow: hidden;
          .clock{
            float: right;
            margin-top: .535rem;
            padding-right: .4rem;
            i{
              width: 1.6rem;
              height: 1.6rem;
              background: url('/static/img/icon-clock.png') no-repeat center center;
              background-size: 100% 100%;
              float: left;
            }
            a{
              float: left;
              font-size: .89rem;
              line-height: 1.6rem;
              text-decoration: underline;
              color: #ffffff;
            }
          }
          .index-live-next-info{
            float: left;
            .con{
              overflow: hidden;
              .time{
                float: left;
                color: #ffffff;
                font-size: .89rem;
                line-height: 2.67rem;
                font-family: HelveticaLTPro-Bold;
                font-weight: 400;
                width: 7rem;
                span{
                  font-size: .78rem;
                  font-family: HelveticaLTPro-Roman;
                  font-weight: normal;
                }
              }
              .title{
                font-size: .78rem;
                font-family: HelveticaLTPro-Roman;
                font-weight: normal;
                color: #ffffff;
                float: left;
                width: 11rem;
                line-height: 2.75rem;
                white-space: nowrap;
                padding-left: 0;
                overflow: hidden;
                span{
                  animation: loopText linear infinite;
                  display: inline-block;
                  &.hoverStyle{
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
      .index-live-nav{
        height: 9.77rem;
        background: url('/static/img/index-live-nav-bg.png') no-repeat;
        background-size: 100% 100%;
        .channel-slide-m{
          width: 100%;
          height: 9.77rem;
          .swiper-slide{
            width: 6rem;
            dl{
              dt{
                width: 4.72rem;
                height: 4.89rem;
                overflow: hidden;
                margin: auto;
                cursor: pointer;
                img{
                  width: 100%;
                }
              }
              dt{
                overflow: hidden;
                width: 3.89rem;
                height: 3.89rem;
                box-shadow: 0 0 .83rem #fff;
                border-radius: 50%;
                background-color: #fbfbfb;
                position: relative;
                margin: .89rem auto 0;
                img{
                  width: 3.33rem;
                  height: 3.33rem;
                  border-radius: 50%;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%,-50%);
                }
                .pic-mask{
                  width: 3.33rem;
                  height: 3.33rem;
                  border-radius: 50%;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%,-50%);
                  box-shadow: inset 0px 0px .83rem 0px rgba(0,0,0,.5);
                  z-index: 2;
                }
                .playingGif{
                  width: 3.33rem;
                  height: 3.33rem;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%,-50%);
                  z-index: 3;
                  display: none;
                  background-color: rgba(0,0,0,.5);
                  border-radius: 50%;
                  img{
                    width: 2.78rem;
                    height: auto;
                    position: absolute;
                    top: -.56rem;
                    left: 50%;
                    transform: translateX(-50%);
                  }
                }
                &.current{
                  .playingGif{
                    display: block;
                  }
                }
              }
              dd{
                color: #333333;
                text-align: center;
                margin-top: .44rem;
                h3{
                  font-family: HelveticaLTPro-Bold;
                  font-size: 0.83rem;
                  line-height: 1.11rem;
                  font-weight: 400;
                  max-height: 2.22rem;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                p{
                  font-family: HelveticaLTPro-Roman;
                  font-size: 0.78rem;
                  line-height: 1.11rem;
                  max-height: 2.22rem;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }
  }
  @supports (-webkit-backdrop-filter: brightness(20%) blur(5.56rem)) or (backdrop-filter: brightness(20%) blur(5.56rem)){
  /* 支持 backdrop-filter 时应用的效果，记得把一些属性覆盖掉 */
    .index-m-live{
      background-color: transparent;
    }
    .index-live-bg {
      -webkit-backdrop-filter: brightness(20%) blur(5.56rem);
      backdrop-filter: brightness(20%) blur(5.56rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue